// ---------------------------------------------------
// !!! THIS FILE WAS GENERATED BY @graphql-codegen !!!
// !!!   DO NOT MODIFY THIS FILE BY YOURSELF       !!!
// ---------------------------------------------------
import { api } from './gqlBaseQuery';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDateTime: string;
  AWSJSON: string;
  Long: number;
};

export type Business = {
  __typename?: 'Business';
  AssignedAE?: Maybe<Scalars['String']>;
  AssignedBDR?: Maybe<Scalars['String']>;
  AssignedCAM?: Maybe<Scalars['String']>;
  AssignedCSM?: Maybe<Scalars['String']>;
  AssignedSE?: Maybe<Scalars['String']>;
  AssignedSetupRep?: Maybe<Scalars['String']>;
  CallRecord?: Maybe<Scalars['Int']>;
  DncBlocksOutboundSMS?: Maybe<Scalars['Int']>;
  FSaccountid?: Maybe<Scalars['String']>;
  FollowUpSMSActive?: Maybe<Scalars['Int']>;
  LocalPresenceType?: Maybe<Scalars['String']>;
  PlivoAuth?: Maybe<Scalars['String']>;
  SEAssignedDate?: Maybe<Scalars['AWSDateTime']>;
  SMSactive?: Maybe<Scalars['Int']>;
  SubscriptionSMSActive?: Maybe<Scalars['Int']>;
  _count?: Maybe<BusinessCount>;
  accountManagerEmail?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  allowAgentPowerlist: Scalars['Int'];
  apiKey?: Maybe<Scalars['String']>;
  apikeyenabled?: Maybe<Scalars['Int']>;
  applyCustomCRMtoNewUsers?: Maybe<Scalars['Int']>;
  autoAnswerApi?: Maybe<Scalars['Int']>;
  balanceupdated?: Maybe<Scalars['AWSDateTime']>;
  billDay?: Maybe<Scalars['Int']>;
  blockOutboundCallRecordingSetting?: Maybe<Scalars['String']>;
  blocked?: Maybe<Scalars['Int']>;
  businessBillingTerm?: Maybe<Scalars['Int']>;
  businessContractTerm?: Maybe<Scalars['String']>;
  businessDetails?: Maybe<BusinessDetails>;
  businessURL?: Maybe<Scalars['String']>;
  businesscountrycode?: Maybe<Scalars['String']>;
  businessid: Scalars['Long'];
  canDeleteUsers?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clientid: Scalars['Long'];
  connectionDuration?: Maybe<Scalars['Int']>;
  createContact?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['AWSDateTime']>;
  customCRMSearchEndpoint?: Maybe<Scalars['String']>;
  dealClosedBy?: Maybe<Scalars['String']>;
  dealClosedDateTime?: Maybe<Scalars['AWSDateTime']>;
  defaultCrmUserid?: Maybe<Scalars['Long']>;
  directSync?: Maybe<Scalars['Int']>;
  discountEndDate?: Maybe<Scalars['AWSDateTime']>;
  discountPercent?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  emailHash?: Maybe<Scalars['String']>;
  emailVerified?: Maybe<Scalars['Int']>;
  env?: Maybe<Scalars['String']>;
  externalid?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  fromGMT: Scalars['Int'];
  hasCustomCRM?: Maybe<Scalars['Int']>;
  hasSlack?: Maybe<Scalars['Int']>;
  hasWebhook?: Maybe<Scalars['Int']>;
  hashCT?: Maybe<Scalars['Int']>;
  holdMusic: Scalars['String'];
  inboundRingtone?: Maybe<Scalars['String']>;
  invoicedUntil?: Maybe<Scalars['AWSDateTime']>;
  isactive?: Maybe<Scalars['Int']>;
  lastcallid?: Maybe<Scalars['String']>;
  lastcharge?: Maybe<Scalars['AWSDateTime']>;
  lastdataupdate?: Maybe<Scalars['AWSDateTime']>;
  lastinvoicedate?: Maybe<Scalars['AWSDateTime']>;
  lastrechargeinvoice?: Maybe<Scalars['String']>;
  leaderboardSort?: Maybe<Scalars['String']>;
  leadid?: Maybe<Scalars['Long']>;
  maxrate?: Maybe<Scalars['Float']>;
  minimumBalance?: Maybe<Scalars['Float']>;
  minutesBalance?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  onlyManagersCanAddPhoneNumbers?: Maybe<Scalars['Int']>;
  onlyManagersCanViewCallReporting?: Maybe<Scalars['Int']>;
  plivoRegion?: Maybe<Scalars['String']>;
  plivoToken?: Maybe<Scalars['String']>;
  plivoacctid?: Maybe<Scalars['String']>;
  prepaidTrial?: Maybe<Scalars['Int']>;
  publicKey?: Maybe<Scalars['String']>;
  rechargeAmount?: Maybe<Scalars['Float']>;
  recordingRetention?: Maybe<Scalars['Int']>;
  requireOutcomeForAllAgents?: Maybe<Scalars['Boolean']>;
  reserveBalance?: Maybe<Scalars['Float']>;
  salesRepEmail?: Maybe<Scalars['String']>;
  salescycle: Scalars['Int'];
  salescycletype?: Maybe<Scalars['String']>;
  salesforceWebooksDeployed?: Maybe<Scalars['Boolean']>;
  sendRecordingToCRM?: Maybe<Scalars['Int']>;
  setupRepEmail?: Maybe<Scalars['String']>;
  showOutcomeForAllAgents?: Maybe<Scalars['Boolean']>;
  sipRealm?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stopBlocksOutboundCalls?: Maybe<Scalars['Int']>;
  terminatingnumber?: Maybe<Scalars['Int']>;
  timezoneid: Scalars['Int'];
  webhookDelay?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
};

export type BusinessCount = {
  __typename?: 'BusinessCount';
  cadence: Scalars['Int'];
  cadenceProcess: Scalars['Int'];
  powerlist: Scalars['Int'];
  powerlistTeam: Scalars['Int'];
};

export type BusinessDetails = {
  __typename?: 'BusinessDetails';
  apiKeyJson?: Maybe<Scalars['AWSJSON']>;
  business: Business;
  businessHours: Scalars['AWSJSON'];
  businessId: Scalars['Long'];
  callTranscriptionSettings?: Maybe<Scalars['AWSJSON']>;
  createdDate: Scalars['AWSDateTime'];
  displayOnboarding: Scalars['Boolean'];
  localPresencePremiumAction?: Maybe<Scalars['String']>;
  owWizardData?: Maybe<Scalars['AWSJSON']>;
  salesforceWebhookMetadata?: Maybe<Scalars['AWSJSON']>;
  updatedDate: Scalars['AWSDateTime'];
};

export enum BusinessDetailsScalarFieldEnum {
  ApiKeyJson = 'apiKeyJson',
  BusinessHours = 'businessHours',
  BusinessId = 'businessId',
  CallTranscriptionSettings = 'callTranscriptionSettings',
  CreatedDate = 'createdDate',
  DisplayOnboarding = 'displayOnboarding',
  LocalPresencePremiumAction = 'localPresencePremiumAction',
  OwWizardData = 'owWizardData',
  SalesforceWebhookMetadata = 'salesforceWebhookMetadata',
  UpdatedDate = 'updatedDate',
}

export type BusinessProducts = {
  __typename?: 'BusinessProducts';
  businessid: Scalars['Long'];
  businessproductid: Scalars['Long'];
  createdate?: Maybe<Scalars['AWSDateTime']>;
  description?: Maybe<Scalars['String']>;
  enddate?: Maybe<Scalars['AWSDateTime']>;
  includedunits?: Maybe<Scalars['Int']>;
  invoiceduntil?: Maybe<Scalars['AWSDateTime']>;
  numberid?: Maybe<Scalars['Long']>;
  paymentduration?: Maybe<Scalars['Int']>;
  priceperunit?: Maybe<Scalars['Float']>;
  productid?: Maybe<Scalars['Int']>;
  startdate?: Maybe<Scalars['AWSDateTime']>;
  status?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Int']>;
  updatedate?: Maybe<Scalars['AWSDateTime']>;
  userid?: Maybe<Scalars['Long']>;
};

export enum BusinessProductsScalarFieldEnum {
  Businessid = 'businessid',
  Businessproductid = 'businessproductid',
  Createdate = 'createdate',
  Description = 'description',
  Enddate = 'enddate',
  Includedunits = 'includedunits',
  Invoiceduntil = 'invoiceduntil',
  Numberid = 'numberid',
  Paymentduration = 'paymentduration',
  Priceperunit = 'priceperunit',
  Productid = 'productid',
  Startdate = 'startdate',
  Status = 'status',
  Units = 'units',
  Updatedate = 'updatedate',
  Userid = 'userid',
}

export enum BusinessScalarFieldEnum {
  AssignedAe = 'AssignedAE',
  AssignedBdr = 'AssignedBDR',
  AssignedCam = 'AssignedCAM',
  AssignedCsm = 'AssignedCSM',
  AssignedSe = 'AssignedSE',
  AssignedSetupRep = 'AssignedSetupRep',
  CallRecord = 'CallRecord',
  DncBlocksOutboundSms = 'DncBlocksOutboundSMS',
  FSaccountid = 'FSaccountid',
  FollowUpSmsActive = 'FollowUpSMSActive',
  LocalPresenceType = 'LocalPresenceType',
  PlivoAuth = 'PlivoAuth',
  SeAssignedDate = 'SEAssignedDate',
  SmSactive = 'SMSactive',
  SubscriptionSmsActive = 'SubscriptionSMSActive',
  AccountManagerEmail = 'accountManagerEmail',
  Address1 = 'address1',
  AllowAgentPowerlist = 'allowAgentPowerlist',
  ApiKey = 'apiKey',
  Apikeyenabled = 'apikeyenabled',
  ApplyCustomCrMtoNewUsers = 'applyCustomCRMtoNewUsers',
  AutoAnswerApi = 'autoAnswerApi',
  Balanceupdated = 'balanceupdated',
  BillDay = 'billDay',
  BlockOutboundCallRecordingSetting = 'blockOutboundCallRecordingSetting',
  Blocked = 'blocked',
  BusinessBillingTerm = 'businessBillingTerm',
  BusinessContractTerm = 'businessContractTerm',
  BusinessUrl = 'businessURL',
  Businesscountrycode = 'businesscountrycode',
  Businessid = 'businessid',
  CanDeleteUsers = 'canDeleteUsers',
  Category = 'category',
  City = 'city',
  Clientid = 'clientid',
  ConnectionDuration = 'connectionDuration',
  CreateContact = 'createContact',
  Created = 'created',
  CustomCrmSearchEndpoint = 'customCRMSearchEndpoint',
  DealClosedBy = 'dealClosedBy',
  DealClosedDateTime = 'dealClosedDateTime',
  DefaultCrmUserid = 'defaultCrmUserid',
  DirectSync = 'directSync',
  DiscountEndDate = 'discountEndDate',
  DiscountPercent = 'discountPercent',
  Email = 'email',
  EmailHash = 'emailHash',
  EmailVerified = 'emailVerified',
  Env = 'env',
  Externalid = 'externalid',
  Frequency = 'frequency',
  FromGmt = 'fromGMT',
  HasCustomCrm = 'hasCustomCRM',
  HasSlack = 'hasSlack',
  HasWebhook = 'hasWebhook',
  HashCt = 'hashCT',
  HoldMusic = 'holdMusic',
  InboundRingtone = 'inboundRingtone',
  InvoicedUntil = 'invoicedUntil',
  Isactive = 'isactive',
  Lastcallid = 'lastcallid',
  Lastcharge = 'lastcharge',
  Lastdataupdate = 'lastdataupdate',
  Lastinvoicedate = 'lastinvoicedate',
  Lastrechargeinvoice = 'lastrechargeinvoice',
  LeaderboardSort = 'leaderboardSort',
  Leadid = 'leadid',
  Maxrate = 'maxrate',
  MinimumBalance = 'minimumBalance',
  MinutesBalance = 'minutesBalance',
  Name = 'name',
  OnlyManagersCanAddPhoneNumbers = 'onlyManagersCanAddPhoneNumbers',
  OnlyManagersCanViewCallReporting = 'onlyManagersCanViewCallReporting',
  PlivoRegion = 'plivoRegion',
  PlivoToken = 'plivoToken',
  Plivoacctid = 'plivoacctid',
  PrepaidTrial = 'prepaidTrial',
  PublicKey = 'publicKey',
  RechargeAmount = 'rechargeAmount',
  RecordingRetention = 'recordingRetention',
  RequireOutcomeForAllAgents = 'requireOutcomeForAllAgents',
  ReserveBalance = 'reserveBalance',
  SalesRepEmail = 'salesRepEmail',
  Salescycle = 'salescycle',
  Salescycletype = 'salescycletype',
  SalesforceWebooksDeployed = 'salesforceWebooksDeployed',
  SendRecordingToCrm = 'sendRecordingToCRM',
  SetupRepEmail = 'setupRepEmail',
  ShowOutcomeForAllAgents = 'showOutcomeForAllAgents',
  SipRealm = 'sipRealm',
  State = 'state',
  StopBlocksOutboundCalls = 'stopBlocksOutboundCalls',
  Terminatingnumber = 'terminatingnumber',
  Timezoneid = 'timezoneid',
  WebhookDelay = 'webhookDelay',
  Website = 'website',
}

export type Cadence = {
  __typename?: 'Cadence';
  _count?: Maybe<CadenceCount>;
  assignContactOwner: Cadence_AssignContactOwner;
  business: Business;
  businessId: Scalars['Long'];
  cadenceHours: Scalars['AWSJSON'];
  cadenceId: Scalars['Int'];
  cadenceName: Scalars['String'];
  checkDncEnabled: Scalars['Boolean'];
  createdDate: Scalars['AWSDateTime'];
  eventUrl: Scalars['String'];
  queueId?: Maybe<Scalars['Long']>;
  reEnrollmentEnabled: Scalars['Boolean'];
  smsBusinessNumber?: Maybe<Scalars['String']>;
  smsInboxId?: Maybe<Scalars['Int']>;
  smsSender?: Maybe<Cadence_SmsSender>;
  status: Cadence_Status;
  targetHours: Scalars['AWSJSON'];
  updatedDate: Scalars['AWSDateTime'];
  useBusinessCadenceHoursEnabled: Scalars['Boolean'];
  useBusinessHarassmentPolicyEnabled: Scalars['Boolean'];
  useBusinessTargetHoursEnabled: Scalars['Boolean'];
  useContactOwnerEnabled: Scalars['Boolean'];
  version: Scalars['Int'];
};

export type CadenceCount = {
  __typename?: 'CadenceCount';
  cadenceProcess: Scalars['Int'];
};

export type CadenceProcess = {
  __typename?: 'CadenceProcess';
  business: Business;
  businessId: Scalars['Long'];
  cadence: Cadence;
  cadenceId: Scalars['Int'];
  cadenceProcessId: Scalars['Int'];
  cadenceVersion: Scalars['Int'];
  createdDate: Scalars['AWSDateTime'];
  displayname?: Maybe<Scalars['String']>;
  environment?: Maybe<Scalars['String']>;
  originatingDomainName?: Maybe<Scalars['String']>;
  smsBusinessNumber?: Maybe<Scalars['String']>;
  smsInboxId?: Maybe<Scalars['Int']>;
  smsSender?: Maybe<CadenceProcess_SmsSender>;
  status: CadenceProcess_Status;
  substatus?: Maybe<CadenceProcess_Substatus>;
  targetPhoneNumber: Scalars['String'];
  targetTimeZone: Scalars['String'];
  triggerDate: Scalars['AWSDateTime'];
  updatedDate: Scalars['AWSDateTime'];
  userId?: Maybe<Scalars['Long']>;
  users?: Maybe<Users>;
};

export enum CadenceProcessScalarFieldEnum {
  BusinessId = 'businessId',
  CadenceId = 'cadenceId',
  CadenceProcessId = 'cadenceProcessId',
  CadenceVersion = 'cadenceVersion',
  CreatedDate = 'createdDate',
  Displayname = 'displayname',
  Environment = 'environment',
  OriginatingDomainName = 'originatingDomainName',
  SmsBusinessNumber = 'smsBusinessNumber',
  SmsInboxId = 'smsInboxId',
  SmsSender = 'smsSender',
  Status = 'status',
  Substatus = 'substatus',
  TargetPhoneNumber = 'targetPhoneNumber',
  TargetTimeZone = 'targetTimeZone',
  TriggerDate = 'triggerDate',
  UpdatedDate = 'updatedDate',
  UserId = 'userId',
}

export enum CadenceScalarFieldEnum {
  AssignContactOwner = 'assignContactOwner',
  BusinessId = 'businessId',
  CadenceHours = 'cadenceHours',
  CadenceId = 'cadenceId',
  CadenceName = 'cadenceName',
  CheckDncEnabled = 'checkDncEnabled',
  CreatedDate = 'createdDate',
  EventUrl = 'eventUrl',
  QueueId = 'queueId',
  ReEnrollmentEnabled = 'reEnrollmentEnabled',
  SmsBusinessNumber = 'smsBusinessNumber',
  SmsInboxId = 'smsInboxId',
  SmsSender = 'smsSender',
  Status = 'status',
  TargetHours = 'targetHours',
  UpdatedDate = 'updatedDate',
  UseBusinessCadenceHoursEnabled = 'useBusinessCadenceHoursEnabled',
  UseBusinessHarassmentPolicyEnabled = 'useBusinessHarassmentPolicyEnabled',
  UseBusinessTargetHoursEnabled = 'useBusinessTargetHoursEnabled',
  UseContactOwnerEnabled = 'useContactOwnerEnabled',
  Version = 'version',
}

export enum EColor {
  Blue = 'blue',
  Green = 'green',
  Red = 'red',
}

export enum EEventGroup {
  BusinessSms = 'businessSMS',
  BusinessSettings = 'businessSettings',
  Call = 'call',
  Counter = 'counter',
  Directory = 'directory',
  Login = 'login',
  Powerlist = 'powerlist',
  Unknown = 'unknown',
  UserSettings = 'userSettings',
}

export enum EEventType {
  UpdateBusinessSettings = 'UpdateBusinessSettings',
  UpdatePowerlistSessionStatus = 'UpdatePowerlistSessionStatus',
  UpdateSnackbarMessage = 'UpdateSnackbarMessage',
  Batch = 'batch',
  Gcm = 'gcm',
  Login = 'login',
  Logout = 'logout',
  Powerlist = 'powerlist',
  SmsLock = 'smsLock',
  SmsReply = 'smsReply',
  SmsSend = 'smsSend',
  Status = 'status',
  UpdatePowerlistSubscriptions = 'updatePowerlistSubscriptions',
  UpdateReservedNumbers = 'updateReservedNumbers',
}

export enum ELocation {
  Apigateway = 'apigateway',
  Appsync = 'appsync',
  Dash = 'dash',
  Php = 'php',
  Powercall = 'powercall',
}

export enum ELogLevel {
  All = 'all',
  Debug = 'debug',
  Error = 'error',
  Fatal = 'fatal',
  Info = 'info',
  Off = 'off',
  Trace = 'trace',
  Warn = 'warn',
}

export enum ENodeEnv {
  Development = 'development',
  Production = 'production',
  Test = 'test',
}

export enum ERole {
  Admin = 'admin',
  Manager = 'manager',
  Superadmin = 'superadmin',
  User = 'user',
}

export type Mutation = {
  __typename?: 'Mutation';
  createEvent?: Maybe<TEvent>;
  deletePowerlistContact?: Maybe<TDeletePowerlistContactOutput>;
  dialCurrentPowerlistTarget?: Maybe<TPowerlistResponse>;
  dialNextPowerlist?: Maybe<TPowerlistResponse>;
  endPowerlistSession?: Maybe<TPowerlistResponse>;
  login?: Maybe<TAllSettings>;
  login2?: Maybe<TAllSettings>;
  pausePowerlistSession?: Maybe<TPowerlistResponse>;
  reschedulePowerlistContact?: Maybe<TReschedulePowerlistContactOutput>;
  reservePowerlistContacts?: Maybe<TPowerlistReserveContactResponse>;
  resumePowerlistSession?: Maybe<TPowerlistResponse>;
  saveOutcomePowerlist?: Maybe<TSaveOutcomeOutput>;
  startDialing?: Maybe<TPowerlistResponse>;
  subscribePowerlists?: Maybe<TSubscribePowerlistsOutput>;
};

export type MutationCreateEventArgs = {
  auth: TAuthInput;
  event: TEventInput;
};

export type MutationDeletePowerlistContactArgs = {
  powerlistContactId?: InputMaybe<Scalars['Int']>;
};

export type MutationDialCurrentPowerlistTargetArgs = {
  sessionId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type MutationDialNextPowerlistArgs = {
  sessionId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type MutationEndPowerlistSessionArgs = {
  sessionId?: InputMaybe<Scalars['Int']>;
};

export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  source: ELocation;
};

export type MutationLogin2Args = {
  email: Scalars['String'];
  password: Scalars['String'];
  source: ELocation;
};

export type MutationPausePowerlistSessionArgs = {
  businessId?: InputMaybe<Scalars['Int']>;
  sessionId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Long']>;
};

export type MutationReschedulePowerlistContactArgs = {
  powerlistContactId?: InputMaybe<Scalars['Int']>;
};

export type MutationReservePowerlistContactsArgs = {
  sessionId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Long']>;
};

export type MutationResumePowerlistSessionArgs = {
  businessId?: InputMaybe<Scalars['Int']>;
  sessionId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Long']>;
};

export type MutationSaveOutcomePowerlistArgs = {
  callId: Scalars['Int'];
  dispositionId: Scalars['Int'];
  externalCallId: Scalars['String'];
  nextAppointment?: InputMaybe<Scalars['String']>;
  nextCallRefresher: Scalars['String'];
  outcome?: InputMaybe<Scalars['String']>;
  outcomeCreatedBy?: InputMaybe<Scalars['Int']>;
  outcomeUpdateDateTime?: InputMaybe<Scalars['String']>;
  powerlistContactId: Scalars['Int'];
  powerlistId: Scalars['Int'];
  refesherUpdateDateTime: Scalars['String'];
  refresherCreatedBy: Scalars['Int'];
  smsTemplate?: InputMaybe<Scalars['String']>;
  userId: Scalars['Long'];
};

export type MutationStartDialingArgs = {
  businessId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Long']>;
};

export type MutationSubscribePowerlistsArgs = {
  powerlistIds: Array<Scalars['Int']>;
  subscribe: Scalars['Int'];
  userId: Scalars['Long'];
};

export type Powerlist = {
  __typename?: 'Powerlist';
  _count?: Maybe<PowerlistCount>;
  assignToAgentOnAnswer: Scalars['Int'];
  autostartOnLogon: Scalars['Int'];
  business: Business;
  businessId: Scalars['Long'];
  createdByUserId: Scalars['Long'];
  createdDate: Scalars['AWSDateTime'];
  dialAtATime: Scalars['Int'];
  hangupOnMachineAnswers?: Maybe<Scalars['Int']>;
  ignoreDNC: Scalars['Boolean'];
  isAgentPowerlist: Scalars['Int'];
  maxAttempts: Scalars['Int'];
  maxAttemptsPerDay: Scalars['Int'];
  maxSmsPerTemplateCount: Scalars['Int'];
  maxSmsPerTemplateDurationInMin: Scalars['Int'];
  maxWaitAfterCallInSec: Scalars['Int'];
  minDurationBeforeCallRetryInMin: Scalars['Int'];
  mustDespositionCalls: Scalars['Int'];
  name: Scalars['String'];
  onlyDialFromOwnerIfOwned?: Maybe<Scalars['Int']>;
  overrideOwnerOnAnswer: Scalars['Int'];
  powerlistHours?: Maybe<Scalars['AWSJSON']>;
  powerlistId: Scalars['Int'];
  secondsBeforeTimeout: Scalars['Int'];
  statAnswered: Scalars['Int'];
  statConnected: Scalars['Int'];
  statDialed: Scalars['Int'];
  statTalkTimeInSec: Scalars['Int'];
  status: Powerlist_Status;
  targetHours?: Maybe<Scalars['AWSJSON']>;
  updatedDate: Scalars['AWSDateTime'];
  useBusinessHoursForPowerlist: Scalars['Int'];
  useBusinessHoursForTarget: Scalars['Int'];
  users: Users;
};

export type PowerlistContact = {
  __typename?: 'PowerlistContact';
  attemptCount: Scalars['Int'];
  companyName?: Maybe<Scalars['String']>;
  createdDate: Scalars['AWSDateTime'];
  crmContactId?: Maybe<Scalars['String']>;
  deferredReason?: Maybe<PowerlistContact_DeferredReason>;
  dstEndDate?: Maybe<Scalars['AWSDateTime']>;
  dstNextUpdateTimestamp?: Maybe<Scalars['AWSDateTime']>;
  dstStartDate?: Maybe<Scalars['AWSDateTime']>;
  email?: Maybe<Scalars['String']>;
  externalOwnerId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastAttemptDateTime?: Maybe<Scalars['AWSDateTime']>;
  lastDialOutcome?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  nextCallRefresher?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  outcomeCreatedBy?: Maybe<Scalars['Long']>;
  outcomeUpdateDateTime?: Maybe<Scalars['AWSDateTime']>;
  ownerUserId?: Maybe<Scalars['Long']>;
  phoneNumber: Scalars['String'];
  phoneNumber164: Scalars['String'];
  powerlist: Powerlist;
  powerlistContactId: Scalars['Int'];
  powerlistId: Scalars['Int'];
  powerlistSpreadsheet?: Maybe<PowerlistSpreadsheet>;
  powerlistSpreadsheetId?: Maybe<Scalars['Int']>;
  refesherUpdateDateTime?: Maybe<Scalars['AWSDateTime']>;
  refresherCreatedBy?: Maybe<Scalars['Long']>;
  reservedDate?: Maybe<Scalars['AWSDateTime']>;
  reservedForUserId?: Maybe<Scalars['Long']>;
  retryAfterDateTime?: Maybe<Scalars['AWSDateTime']>;
  rowNumber?: Maybe<Scalars['Int']>;
  ssData?: Maybe<Scalars['AWSJSON']>;
  statAnswered?: Maybe<Scalars['Int']>;
  statConnected?: Maybe<Scalars['Int']>;
  statTalkTimeinSec?: Maybe<Scalars['Int']>;
  status: PowerlistContact_Status;
  targetTimeZone: Scalars['String'];
  targetTimeZoneDst: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  users?: Maybe<Users>;
  users_powerlistContact_outcomeCreatedByTousers?: Maybe<Users>;
  users_powerlistContact_refresherCreatedByTousers?: Maybe<Users>;
};

export enum PowerlistContactScalarFieldEnum {
  AttemptCount = 'attemptCount',
  CompanyName = 'companyName',
  CreatedDate = 'createdDate',
  CrmContactId = 'crmContactId',
  DeferredReason = 'deferredReason',
  DstEndDate = 'dstEndDate',
  DstNextUpdateTimestamp = 'dstNextUpdateTimestamp',
  DstStartDate = 'dstStartDate',
  Email = 'email',
  ExternalOwnerId = 'externalOwnerId',
  FirstName = 'firstName',
  LastAttemptDateTime = 'lastAttemptDateTime',
  LastDialOutcome = 'lastDialOutcome',
  LastName = 'lastName',
  NextCallRefresher = 'nextCallRefresher',
  Outcome = 'outcome',
  OutcomeCreatedBy = 'outcomeCreatedBy',
  OutcomeUpdateDateTime = 'outcomeUpdateDateTime',
  OwnerUserId = 'ownerUserId',
  PhoneNumber = 'phoneNumber',
  PhoneNumber164 = 'phoneNumber164',
  PowerlistContactId = 'powerlistContactId',
  PowerlistId = 'powerlistId',
  PowerlistSpreadsheetId = 'powerlistSpreadsheetId',
  RefesherUpdateDateTime = 'refesherUpdateDateTime',
  RefresherCreatedBy = 'refresherCreatedBy',
  ReservedDate = 'reservedDate',
  ReservedForUserId = 'reservedForUserId',
  RetryAfterDateTime = 'retryAfterDateTime',
  RowNumber = 'rowNumber',
  SsData = 'ssData',
  StatAnswered = 'statAnswered',
  StatConnected = 'statConnected',
  StatTalkTimeinSec = 'statTalkTimeinSec',
  Status = 'status',
  TargetTimeZone = 'targetTimeZone',
  TargetTimeZoneDst = 'targetTimeZoneDst',
  Title = 'title',
}

export type PowerlistCount = {
  __typename?: 'PowerlistCount';
  powerlistContact: Scalars['Int'];
  powerlistDispositionRule: Scalars['Int'];
  powerlistSpreadsheet: Scalars['Int'];
  powerlistTeam: Scalars['Int'];
};

export type PowerlistDispositionRule = {
  __typename?: 'PowerlistDispositionRule';
  action: PowerlistDispositionRule_Action;
  businessDispositionId: Scalars['Long'];
  forwardToCadenceId?: Maybe<Scalars['Int']>;
  forwardToPowerlistId?: Maybe<Scalars['Int']>;
  powerlist: Powerlist;
  powerlistDispositionRuleId: Scalars['Int'];
  powerlistId: Scalars['Int'];
  smsTemplateId?: Maybe<Scalars['Long']>;
  smsTemplates?: Maybe<SmsTemplates>;
  status: PowerlistDispositionRule_Status;
};

export enum PowerlistDispositionRuleScalarFieldEnum {
  Action = 'action',
  BusinessDispositionId = 'businessDispositionId',
  ForwardToCadenceId = 'forwardToCadenceId',
  ForwardToPowerlistId = 'forwardToPowerlistId',
  PowerlistDispositionRuleId = 'powerlistDispositionRuleId',
  PowerlistId = 'powerlistId',
  SmsTemplateId = 'smsTemplateId',
  Status = 'status',
}

export enum PowerlistScalarFieldEnum {
  AssignToAgentOnAnswer = 'assignToAgentOnAnswer',
  AutostartOnLogon = 'autostartOnLogon',
  BusinessId = 'businessId',
  CreatedByUserId = 'createdByUserId',
  CreatedDate = 'createdDate',
  DialAtATime = 'dialAtATime',
  HangupOnMachineAnswers = 'hangupOnMachineAnswers',
  IgnoreDnc = 'ignoreDNC',
  IsAgentPowerlist = 'isAgentPowerlist',
  MaxAttempts = 'maxAttempts',
  MaxAttemptsPerDay = 'maxAttemptsPerDay',
  MaxSmsPerTemplateCount = 'maxSmsPerTemplateCount',
  MaxSmsPerTemplateDurationInMin = 'maxSmsPerTemplateDurationInMin',
  MaxWaitAfterCallInSec = 'maxWaitAfterCallInSec',
  MinDurationBeforeCallRetryInMin = 'minDurationBeforeCallRetryInMin',
  MustDespositionCalls = 'mustDespositionCalls',
  Name = 'name',
  OnlyDialFromOwnerIfOwned = 'onlyDialFromOwnerIfOwned',
  OverrideOwnerOnAnswer = 'overrideOwnerOnAnswer',
  PowerlistHours = 'powerlistHours',
  PowerlistId = 'powerlistId',
  SecondsBeforeTimeout = 'secondsBeforeTimeout',
  StatAnswered = 'statAnswered',
  StatConnected = 'statConnected',
  StatDialed = 'statDialed',
  StatTalkTimeInSec = 'statTalkTimeInSec',
  Status = 'status',
  TargetHours = 'targetHours',
  UpdatedDate = 'updatedDate',
  UseBusinessHoursForPowerlist = 'useBusinessHoursForPowerlist',
  UseBusinessHoursForTarget = 'useBusinessHoursForTarget',
}

export type PowerlistSpreadsheet = {
  __typename?: 'PowerlistSpreadsheet';
  _count?: Maybe<PowerlistSpreadsheetCount>;
  awsS3Key: Scalars['String'];
  duplicateHandling: PowerlistSpreadsheet_DuplicateHandling;
  errorCount: Scalars['Int'];
  errorFileS3Key?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  powerlist: Powerlist;
  powerlistId: Scalars['Int'];
  powerlistSpreadsheetId: Scalars['Int'];
  status: PowerlistSpreadsheet_Status;
  uploadDate: Scalars['AWSDateTime'];
  uploadedByUserId: Scalars['Long'];
  users: Users;
  validCount: Scalars['Int'];
  warningCount: Scalars['Int'];
};

export type PowerlistSpreadsheetCount = {
  __typename?: 'PowerlistSpreadsheetCount';
  powerlistContact: Scalars['Int'];
};

export enum PowerlistSpreadsheetScalarFieldEnum {
  AwsS3Key = 'awsS3Key',
  DuplicateHandling = 'duplicateHandling',
  ErrorCount = 'errorCount',
  ErrorFileS3Key = 'errorFileS3Key',
  Name = 'name',
  PowerlistId = 'powerlistId',
  PowerlistSpreadsheetId = 'powerlistSpreadsheetId',
  Status = 'status',
  UploadDate = 'uploadDate',
  UploadedByUserId = 'uploadedByUserId',
  ValidCount = 'validCount',
  WarningCount = 'warningCount',
}

export type PowerlistTeam = {
  __typename?: 'PowerlistTeam';
  _count?: Maybe<PowerlistTeamCount>;
  business: Business;
  businessId: Scalars['Long'];
  powerlist: Powerlist;
  powerlistId: Scalars['Int'];
  powerlistTeamId: Scalars['Int'];
  teamId: Scalars['Long'];
};

export type PowerlistTeamCount = {
  __typename?: 'PowerlistTeamCount';
  powerlistTeamUserSubscription: Scalars['Int'];
};

export enum PowerlistTeamScalarFieldEnum {
  BusinessId = 'businessId',
  PowerlistId = 'powerlistId',
  PowerlistTeamId = 'powerlistTeamId',
  TeamId = 'teamId',
}

export type PowerlistTeamUserSubscription = {
  __typename?: 'PowerlistTeamUserSubscription';
  isSubscribed: Scalars['Int'];
  powerlistTeam: PowerlistTeam;
  powerlistTeamId: Scalars['Int'];
  userId: Scalars['Long'];
  users: Users;
};

export enum PowerlistTeamUserSubscriptionScalarFieldEnum {
  IsSubscribed = 'isSubscribed',
  PowerlistTeamId = 'powerlistTeamId',
  UserId = 'userId',
}

export type PowerlistUserSession = {
  __typename?: 'PowerlistUserSession';
  curPowerlistId?: Maybe<Scalars['Int']>;
  powerlistUserSessionId: Scalars['Int'];
  sessionCreateDateTime: Scalars['AWSDateTime'];
  sessionDurationInSec: Scalars['Int'];
  sessionEndDateTime?: Maybe<Scalars['AWSDateTime']>;
  sessionStartDateTime?: Maybe<Scalars['AWSDateTime']>;
  statAnswered: Scalars['Int'];
  statConnected: Scalars['Int'];
  statDialed: Scalars['Int'];
  statTalkTimeInSec: Scalars['Int'];
  status: PowerlistUserSession_Status;
  statusIntervals: Scalars['AWSJSON'];
  userId: Scalars['Long'];
  users: Users;
};

export enum PowerlistUserSessionScalarFieldEnum {
  CurPowerlistId = 'curPowerlistId',
  PowerlistUserSessionId = 'powerlistUserSessionId',
  SessionCreateDateTime = 'sessionCreateDateTime',
  SessionDurationInSec = 'sessionDurationInSec',
  SessionEndDateTime = 'sessionEndDateTime',
  SessionStartDateTime = 'sessionStartDateTime',
  StatAnswered = 'statAnswered',
  StatConnected = 'statConnected',
  StatDialed = 'statDialed',
  StatTalkTimeInSec = 'statTalkTimeInSec',
  Status = 'status',
  StatusIntervals = 'statusIntervals',
  UserId = 'userId',
}

export type Query = {
  __typename?: 'Query';
  connection: TConnection;
  connection2: TConnection;
  directory?: Maybe<Array<Maybe<TDirectoryOutput>>>;
  getPowerlistUserSession?: Maybe<TPowerlistUserSessionOutput>;
  getPowerlistWithTeamByUserId?: Maybe<
    Array<Maybe<TGetPowerlistWithTeamByUserIdOutput>>
  >;
  getReservedContacts?: Maybe<Array<Maybe<TReservedContactsOutput>>>;
  testResolver: Array<Users>;
};

export type QueryDirectoryArgs = {
  apikey?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['Long']>;
};

export type QueryGetPowerlistUserSessionArgs = {
  accessToken?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['Long']>;
  powerlistUserSessionId?: InputMaybe<Scalars['Int']>;
  userid?: InputMaybe<Scalars['Long']>;
};

export type QueryGetPowerlistWithTeamByUserIdArgs = {
  userid?: InputMaybe<Scalars['Long']>;
};

export type QueryGetReservedContactsArgs = {
  powerlistId?: InputMaybe<Scalars['Int']>;
  powerlistUserSessionId?: InputMaybe<Scalars['Int']>;
  userid?: InputMaybe<Scalars['Long']>;
};

export type QueryTestResolverArgs = {
  userIds: Array<Scalars['Long']>;
};

export type SmsTemplates = {
  __typename?: 'SmsTemplates';
  _count?: Maybe<SmsTemplatesCount>;
  businessid?: Maybe<Scalars['Long']>;
  hasCustomField: Scalars['Boolean'];
  isactive?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  smsTemplateMessage?: Maybe<Scalars['String']>;
  smsTemplateName?: Maybe<Scalars['String']>;
  smsTemplateid: Scalars['Long'];
  userid?: Maybe<Scalars['Long']>;
};

export type SmsTemplatesCount = {
  __typename?: 'SmsTemplatesCount';
  powerlistDispositionRule: Scalars['Int'];
};

export enum SmsTemplatesScalarFieldEnum {
  Businessid = 'businessid',
  HasCustomField = 'hasCustomField',
  Isactive = 'isactive',
  Order = 'order',
  SmsTemplateMessage = 'smsTemplateMessage',
  SmsTemplateName = 'smsTemplateName',
  SmsTemplateid = 'smsTemplateid',
  Userid = 'userid',
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export type Subscription = {
  __typename?: 'Subscription';
  onCreateEvent?: Maybe<TEvent>;
};

export type SubscriptionOnCreateEventArgs = {
  businessId?: InputMaybe<Scalars['Long']>;
  group?: InputMaybe<EEventGroup>;
  target?: InputMaybe<ELocation>;
  topicId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Long']>;
};

export type TAllSettings = {
  __typename?: 'TAllSettings';
  loginSettings?: Maybe<TLoginSettings>;
  userProducts?: Maybe<Array<Maybe<TUserProducts>>>;
  userSettings?: Maybe<TUserSettings>;
};

export type TAuthInput = {
  apikey?: InputMaybe<Scalars['String']>;
};

export type TConnection = {
  __typename?: 'TConnection';
  apiKey: Scalars['String'];
  color: EColor;
  deployVersion: Scalars['String'];
  nodeEnv: ENodeEnv;
  originUrl: Scalars['String'];
  region: Scalars['String'];
};

export type TDefaultDevice = {
  __typename?: 'TDefaultDevice';
  defaultC2C?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
};

export type TDeletePowerlistContactOutput = {
  __typename?: 'TDeletePowerlistContactOutput';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TDevice = {
  __typename?: 'TDevice';
  DID?: Maybe<Scalars['String']>;
  createdate?: Maybe<Scalars['String']>;
  cred?: Maybe<Scalars['String']>;
  deviceName?: Maybe<Scalars['String']>;
  deviceType?: Maybe<Scalars['String']>;
  deviceid?: Maybe<Scalars['String']>;
  didCountryCode?: Maybe<Scalars['String']>;
  endpointid?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['Int']>;
  phoneType?: Maybe<Scalars['String']>;
  sipAddress?: Maybe<Scalars['String']>;
  sipUserId?: Maybe<Scalars['Int']>;
  updatedate?: Maybe<Scalars['String']>;
  userId: Scalars['Long'];
  zohoUserId?: Maybe<Scalars['String']>;
};

export type TDirectoryOutput = {
  __typename?: 'TDirectoryOutput';
  DND?: Maybe<Scalars['Int']>;
  b: Scalars['String'];
  callStart?: Maybe<Scalars['String']>;
  canBeManaged?: Maybe<Scalars['Int']>;
  canCallCoach?: Maybe<Scalars['Int']>;
  confName?: Maybe<Scalars['String']>;
  crmlink?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  customerNumber?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  direction?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['Int']>;
  externalid?: Maybe<Scalars['String']>;
  loggedin?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  oncall?: Maybe<Scalars['Int']>;
  u: Scalars['String'];
};

export type TErrorMessage = {
  __typename?: 'TErrorMessage';
  errorMessage?: Maybe<Scalars['String']>;
};

export type TEvent = {
  __typename?: 'TEvent';
  businessId?: Maybe<Scalars['Long']>;
  group?: Maybe<EEventGroup>;
  id?: Maybe<Scalars['ID']>;
  payload?: Maybe<Scalars['String']>;
  source?: Maybe<ELocation>;
  target?: Maybe<ELocation>;
  topicId?: Maybe<Scalars['String']>;
  type?: Maybe<EEventType>;
  userId?: Maybe<Scalars['Long']>;
};

export type TEventInput = {
  businessId?: InputMaybe<Scalars['Long']>;
  group?: InputMaybe<EEventGroup>;
  id?: InputMaybe<Scalars['ID']>;
  payload?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<ELocation>;
  target?: InputMaybe<ELocation>;
  topicId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<EEventType>;
  userId?: InputMaybe<Scalars['Long']>;
};

export type TGetPowerlistWithTeamByUserIdOutput = {
  __typename?: 'TGetPowerlistWithTeamByUserIdOutput';
  assignToAgentOnAnswer?: Maybe<Scalars['Int']>;
  autostartOnLogon?: Maybe<Scalars['Int']>;
  businessId?: Maybe<Scalars['Long']>;
  countDeferred?: Maybe<Scalars['Int']>;
  countQueued?: Maybe<Scalars['Int']>;
  createdByUserId?: Maybe<Scalars['Int']>;
  createdDate?: Maybe<Scalars['String']>;
  dialAtATime?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  fname?: Maybe<Scalars['String']>;
  hangupOnMachineAnswers?: Maybe<Scalars['Int']>;
  isAgentPowerlist?: Maybe<Scalars['Int']>;
  isSubscribed?: Maybe<Scalars['Int']>;
  lname?: Maybe<Scalars['String']>;
  maxAttempts?: Maybe<Scalars['Int']>;
  maxAttemptsPerDay?: Maybe<Scalars['Int']>;
  maxSmsPerTemplateCount?: Maybe<Scalars['Int']>;
  maxSmsPerTemplateDurationInMin?: Maybe<Scalars['Int']>;
  maxWaitAfterCallInSec?: Maybe<Scalars['Int']>;
  minDurationBeforeCallRetyInMin?: Maybe<Scalars['Int']>;
  mustDespositionCalls?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  onlyDialFromOwnerIfOwned?: Maybe<Scalars['Int']>;
  overrideOwnerOnAnswer?: Maybe<Scalars['Int']>;
  powerlistHours?: Maybe<Scalars['String']>;
  powerlistId?: Maybe<Scalars['Int']>;
  powerlistPriority?: Maybe<Scalars['Int']>;
  powerlistTeamId?: Maybe<Scalars['Int']>;
  secondsBeforeTimeout?: Maybe<Scalars['Int']>;
  statAnswered?: Maybe<Scalars['Int']>;
  statConnected?: Maybe<Scalars['Int']>;
  statDialed?: Maybe<Scalars['Int']>;
  statTalkTimeInSec?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  targetHours?: Maybe<Scalars['String']>;
  teamInfo?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  useBusinessHoursForPowerlist?: Maybe<Scalars['Int']>;
  useBusinessHoursForTarget?: Maybe<Scalars['Int']>;
  userid?: Maybe<Scalars['Long']>;
};

export type TLoginSettings = {
  __typename?: 'TLoginSettings';
  C2Con: Scalars['Boolean'];
  DIDGreeting?: Maybe<Scalars['String']>;
  DIDNoActionAnswer?: Maybe<Scalars['String']>;
  DIDRingAudio?: Maybe<Scalars['String']>;
  DND: Scalars['Boolean'];
  Disposeon: Scalars['Boolean'];
  FSCallFlowID?: Maybe<Scalars['String']>;
  FSuserID?: Maybe<Scalars['String']>;
  FSvmID?: Maybe<Scalars['String']>;
  LightModeon: Scalars['Boolean'];
  PlivoUser: Scalars['Boolean'];
  PowerListEarliestCall: Scalars['Int'];
  PowerListLatestCall: Scalars['Int'];
  allowMultipleIncomingCalls: Scalars['Boolean'];
  audioDeviceEcho: Scalars['Boolean'];
  audioDeviceGain: Scalars['Boolean'];
  audioDeviceNoise: Scalars['Boolean'];
  billingType?: Maybe<Scalars['String']>;
  callerid: Scalars['String'];
  calleridName: Scalars['String'];
  canBeManaged: Scalars['Boolean'];
  canCallCoach: Scalars['Boolean'];
  canCallCoach2: Scalars['Boolean'];
  capsuleUserName?: Maybe<Scalars['String']>;
  cellCC?: Maybe<Scalars['String']>;
  cellNumber?: Maybe<Scalars['String']>;
  closedAction?: Maybe<Scalars['String']>;
  compactMode?: Maybe<Scalars['String']>;
  countrycode: Scalars['String'];
  created?: Maybe<Scalars['String']>;
  defaultC2C?: Maybe<Scalars['String']>;
  defaultDevice?: Maybe<TDefaultDevice>;
  defaultExtend?: Maybe<Scalars['Boolean']>;
  devices?: Maybe<Array<Maybe<TDevice>>>;
  dispose: Scalars['Boolean'];
  email: Scalars['String'];
  fname?: Maybe<Scalars['String']>;
  ftcBlocking: Scalars['Boolean'];
  hasCell?: Maybe<Scalars['Boolean']>;
  inPowerlistSession: Scalars['Boolean'];
  inactiveDate?: Maybe<Scalars['String']>;
  isactive?: Maybe<Scalars['Boolean']>;
  lname?: Maybe<Scalars['String']>;
  localPresenceLite: Scalars['Boolean'];
  localPresenceOn: Scalars['Boolean'];
  localPresenceProgressive: Scalars['Boolean'];
  mediaMetricsOn: Scalars['Boolean'];
  newUser: Scalars['Boolean'];
  orig_email?: Maybe<Scalars['String']>;
  othersCanViewRecordings: Scalars['Boolean'];
  overrideDnc: Scalars['Boolean'];
  pass2?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  playEndSound: Scalars['Boolean'];
  playStartSound: Scalars['Boolean'];
  pop: Scalars['Boolean'];
  preferredServer: Scalars['String'];
  ptype?: Maybe<Scalars['Int']>;
  quietMode: Scalars['Boolean'];
  recordCalls: Scalars['Boolean'];
  sendRecordingtoCRM: Scalars['Boolean'];
  setSuperadminPermissions: Scalars['Boolean'];
  showDispostion: Scalars['Boolean'];
  smsDID?: Maybe<Scalars['String']>;
  styleMode?: Maybe<Scalars['String']>;
  switchUser: Scalars['Boolean'];
  systemTeamId?: Maybe<Scalars['Int']>;
  temp_password?: Maybe<Scalars['Int']>;
  type: ERole;
  useBusinessHoursEnabled: Scalars['Boolean'];
  useCellService: Scalars['Boolean'];
  userEXT: Scalars['Int'];
  userHours?: Maybe<Scalars['String']>;
  userTier: Scalars['String'];
  userid: Scalars['Long'];
  userscol?: Maybe<Scalars['String']>;
  vmDropDetectionType?: Maybe<Scalars['String']>;
  webrtcAudio?: Maybe<Scalars['String']>;
  webrtcAudioLabel?: Maybe<Scalars['String']>;
  webrtcMic?: Maybe<Scalars['String']>;
  webrtcMicLabel?: Maybe<Scalars['String']>;
  webrtcRing?: Maybe<Scalars['String']>;
  webrtcRingLabel?: Maybe<Scalars['String']>;
};

export type TPowerlistDeferredReason = {
  __typename?: 'TPowerlistDeferredReason';
  count?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
};

export type TPowerlistDeferredSummary = {
  __typename?: 'TPowerlistDeferredSummary';
  powerlistName?: Maybe<Scalars['String']>;
  summary?: Maybe<Array<Maybe<TPowerlistDeferredReason>>>;
};

export type TPowerlistReserveContactResponse = {
  __typename?: 'TPowerlistReserveContactResponse';
  data?: Maybe<Array<Maybe<PowerlistContact>>>;
  deferredData?: Maybe<Array<Maybe<TPowerlistDeferredSummary>>>;
  errorMessage?: Maybe<Scalars['String']>;
  sessionData?: Maybe<PowerlistUserSession>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TPowerlistResponse = {
  __typename?: 'TPowerlistResponse';
  contactWaitingForOutcome?: Maybe<Array<Maybe<PowerlistContact>>>;
  data?: Maybe<Array<Maybe<PowerlistContact>>>;
  deferredData?: Maybe<Array<Maybe<TPowerlistDeferredSummary>>>;
  errorMessage?: Maybe<Scalars['String']>;
  sessionData?: Maybe<PowerlistUserSession>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TPowerlistUserSessionOutput = {
  __typename?: 'TPowerlistUserSessionOutput';
  data?: Maybe<PowerlistUserSession>;
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TReschedulePowerlistContactOutput = {
  __typename?: 'TReschedulePowerlistContactOutput';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TReservedContactsOutput = {
  __typename?: 'TReservedContactsOutput';
  attemptCount: Scalars['Int'];
  companyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastAttemptDateTime?: Maybe<Scalars['AWSDateTime']>;
  lastName?: Maybe<Scalars['String']>;
  mustDespositionCalls?: Maybe<Scalars['Int']>;
  nextCallRefresher?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  outcomeCreatedBy?: Maybe<Scalars['Long']>;
  outcomeUpdateDateTime?: Maybe<Scalars['AWSDateTime']>;
  ownerUserId?: Maybe<Scalars['Long']>;
  phoneNumber: Scalars['String'];
  phoneNumber164: Scalars['String'];
  powerlist: Powerlist;
  powerlistContactId: Scalars['Int'];
  powerlistId: Scalars['Int'];
  powerlistName?: Maybe<Scalars['String']>;
  powerlistSpreadsheet: PowerlistSpreadsheet;
  powerlistSpreadsheetId?: Maybe<Scalars['Int']>;
  refesherUpdateDateTime?: Maybe<Scalars['AWSDateTime']>;
  refresherCreatedBy?: Maybe<Scalars['Long']>;
  refresherCreatedByName?: Maybe<Scalars['String']>;
  reservedForUserId?: Maybe<Scalars['Long']>;
  retryAfterDateTime?: Maybe<Scalars['AWSDateTime']>;
  rowNumber?: Maybe<Scalars['Int']>;
  ssData?: Maybe<Scalars['AWSJSON']>;
  status: PowerlistContact_Status;
  targetTimeZone: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  users?: Maybe<Users>;
};

export type TSaveOutcomeOutput = {
  __typename?: 'TSaveOutcomeOutput';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TSubscribePowerlistsOutput = {
  __typename?: 'TSubscribePowerlistsOutput';
  exception?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type TTestOutput = {
  __typename?: 'TTestOutput';
  C2Con?: Maybe<Scalars['Int']>;
  DIDGreeting?: Maybe<Scalars['String']>;
  DIDNoActionAnswer?: Maybe<Scalars['String']>;
  DIDRingAudio?: Maybe<Scalars['String']>;
  DND?: Maybe<Scalars['Int']>;
  Disposeon?: Maybe<Scalars['Int']>;
  FSCallFlowID?: Maybe<Scalars['String']>;
  FSuserID?: Maybe<Scalars['String']>;
  FSvmID?: Maybe<Scalars['String']>;
  LightModeon?: Maybe<Scalars['Int']>;
  PlivoUser?: Maybe<Scalars['Int']>;
  PowerListEarliestCall?: Maybe<Scalars['Float']>;
  PowerListLatestCall?: Maybe<Scalars['Float']>;
  allowMultipleIncomingCalls?: Maybe<Scalars['Int']>;
  audioDeviceEcho?: Maybe<Scalars['Int']>;
  audioDeviceGain?: Maybe<Scalars['Int']>;
  audioDeviceNoise?: Maybe<Scalars['Int']>;
  billingType?: Maybe<Scalars['String']>;
  callerid?: Maybe<Scalars['String']>;
  calleridName?: Maybe<Scalars['String']>;
  canBeManaged?: Maybe<Scalars['Int']>;
  canCallCoach?: Maybe<Scalars['Int']>;
  capsuleUserName?: Maybe<Scalars['String']>;
  closedAction?: Maybe<Scalars['String']>;
  compactMode?: Maybe<Scalars['String']>;
  countrycode?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['AWSDateTime']>;
  defaultC2C?: Maybe<Scalars['String']>;
  dispose?: Maybe<Scalars['Int']>;
  email: Scalars['String'];
  fname?: Maybe<Scalars['String']>;
  ftcBlocking?: Maybe<Scalars['Int']>;
  inPowerlistSession: Scalars['Int'];
  inactiveDate?: Maybe<Scalars['AWSDateTime']>;
  isactive?: Maybe<Scalars['Int']>;
  lname?: Maybe<Scalars['String']>;
  localPresenceLite?: Maybe<Scalars['Int']>;
  localPresenceOn?: Maybe<Scalars['Int']>;
  localPresenceProgressive?: Maybe<Scalars['Int']>;
  mediaMetricsOn?: Maybe<Scalars['Int']>;
  newUser?: Maybe<Scalars['Int']>;
  orig_email?: Maybe<Scalars['String']>;
  othersCanViewRecordings?: Maybe<Scalars['Int']>;
  pass2?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  playEndSound?: Maybe<Scalars['Int']>;
  playStartSound?: Maybe<Scalars['Int']>;
  pop?: Maybe<Scalars['Int']>;
  preferredServer?: Maybe<Scalars['String']>;
  ptype?: Maybe<Scalars['Int']>;
  recordCalls?: Maybe<Scalars['Int']>;
  sendRecordingtoCRM?: Maybe<Scalars['Int']>;
  showDispostion?: Maybe<Scalars['Int']>;
  smsDID?: Maybe<Scalars['String']>;
  styleMode?: Maybe<Scalars['String']>;
  temp_password: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
  useBusinessHoursEnabled: Scalars['Boolean'];
  useCellService?: Maybe<Scalars['Int']>;
  userEXT?: Maybe<Scalars['Int']>;
  userHours?: Maybe<Scalars['AWSJSON']>;
  userTier?: Maybe<Scalars['String']>;
  userid: Scalars['Float'];
  userscol?: Maybe<Scalars['String']>;
  vmDropDetectionType?: Maybe<Scalars['String']>;
  webrtcAudio?: Maybe<Scalars['String']>;
  webrtcAudioLabel?: Maybe<Scalars['String']>;
  webrtcMic?: Maybe<Scalars['String']>;
  webrtcMicLabel?: Maybe<Scalars['String']>;
  webrtcRing?: Maybe<Scalars['String']>;
  webrtcRingLabel?: Maybe<Scalars['String']>;
};

export type TUserProducts = {
  __typename?: 'TUserProducts';
  agentSeat?: Maybe<Scalars['Long']>;
  businessid: Scalars['Long'];
  businessproductid: Scalars['Long'];
  enddate?: Maybe<Scalars['String']>;
  includedunits?: Maybe<Scalars['Long']>;
  numberid?: Maybe<Scalars['Long']>;
  priceperunit?: Maybe<Scalars['Float']>;
  productid: Scalars['Long'];
  startdate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  units?: Maybe<Scalars['Long']>;
  userid?: Maybe<Scalars['Long']>;
};

export type TUserSettings = {
  __typename?: 'TUserSettings';
  accessToken: Scalars['String'];
  allowAgentPowerlist?: Maybe<Scalars['Boolean']>;
  apikey: Scalars['String'];
  businessId: Scalars['Long'];
  callRecord: Scalars['Boolean'];
  canBeManaged: Scalars['Boolean'];
  canCallCoach: Scalars['Boolean'];
  canDeleteUsers: Scalars['Boolean'];
  cardDeclined: Scalars['Boolean'];
  email: Scalars['String'];
  expiresInTimestamp: Scalars['Float'];
  hasBilling: Scalars['Boolean'];
  inTrial: Scalars['Boolean'];
  logLevel?: Maybe<ELogLevel>;
  machineDetectionEnabled: Scalars['Boolean'];
  onlyManagersCanAddPhoneNumbers: Scalars['Boolean'];
  onlyManagersCanViewCallReporting: Scalars['Boolean'];
  refreshToken: Scalars['String'];
  role: ERole;
  tier: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  trialExpired: Scalars['Boolean'];
  userid: Scalars['Long'];
};

export type TViewPowerlistUserOutput = {
  __typename?: 'TViewPowerlistUserOutput';
  assignToAgentOnAnswer?: Maybe<Scalars['Int']>;
  autostartOnLogon?: Maybe<Scalars['Int']>;
  businessId?: Maybe<Scalars['Long']>;
  countDeferred?: Maybe<Scalars['Int']>;
  countQueued?: Maybe<Scalars['Int']>;
  createdByUserId?: Maybe<Scalars['Int']>;
  createdDate?: Maybe<Scalars['String']>;
  dialAtATime?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  fname?: Maybe<Scalars['String']>;
  hangupOnMachineAnswers?: Maybe<Scalars['Int']>;
  isAgentPowerlist?: Maybe<Scalars['Int']>;
  isSubscribed?: Maybe<Scalars['Int']>;
  lastDialedDate?: Maybe<Scalars['String']>;
  lname?: Maybe<Scalars['String']>;
  maxAttempts?: Maybe<Scalars['Int']>;
  maxAttemptsPerDay?: Maybe<Scalars['Int']>;
  maxSmsPerTemplateCount?: Maybe<Scalars['Int']>;
  maxSmsPerTemplateDurationInMin?: Maybe<Scalars['Int']>;
  maxWaitAfterCallInSec?: Maybe<Scalars['Int']>;
  minDurationBeforeCallRetyInMin?: Maybe<Scalars['Int']>;
  mustDespositionCalls?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  onlyDialFromOwnerIfOwned?: Maybe<Scalars['Int']>;
  overrideOwnerOnAnswer?: Maybe<Scalars['Int']>;
  powerlistHours?: Maybe<Scalars['String']>;
  powerlistId?: Maybe<Scalars['Int']>;
  powerlistTeamId?: Maybe<Scalars['Int']>;
  secondsBeforeTimeout?: Maybe<Scalars['Int']>;
  statAnswered?: Maybe<Scalars['Int']>;
  statConnected?: Maybe<Scalars['Int']>;
  statDialed?: Maybe<Scalars['Int']>;
  statTalkTimeInSec?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  targetHours?: Maybe<Scalars['String']>;
  teamInfo?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
  useBusinessHoursForPowerlist?: Maybe<Scalars['Int']>;
  useBusinessHoursForTarget?: Maybe<Scalars['Int']>;
  userid?: Maybe<Scalars['Long']>;
};

export type Timezones = {
  __typename?: 'Timezones';
  timezoneDescription?: Maybe<Scalars['String']>;
  timezone_php?: Maybe<Scalars['String']>;
  timezoneid: Scalars['Int'];
};

export enum TimezonesScalarFieldEnum {
  TimezoneDescription = 'timezoneDescription',
  TimezonePhp = 'timezone_php',
  Timezoneid = 'timezoneid',
}

export type Users = {
  __typename?: 'Users';
  C2Con?: Maybe<Scalars['Int']>;
  DIDGreeting?: Maybe<Scalars['String']>;
  DIDNoActionAnswer?: Maybe<Scalars['String']>;
  DIDRingAudio?: Maybe<Scalars['String']>;
  DND?: Maybe<Scalars['Int']>;
  Disposeon?: Maybe<Scalars['Int']>;
  FSCallFlowID?: Maybe<Scalars['String']>;
  FSuserID?: Maybe<Scalars['String']>;
  FSvmID?: Maybe<Scalars['String']>;
  LightModeon?: Maybe<Scalars['Int']>;
  PlivoUser?: Maybe<Scalars['Int']>;
  PowerListEarliestCall?: Maybe<Scalars['Float']>;
  PowerListLatestCall?: Maybe<Scalars['Float']>;
  _count?: Maybe<UsersCount>;
  agentQueueEnabled: Scalars['Boolean'];
  allowMultipleIncomingCalls?: Maybe<Scalars['Int']>;
  audioDeviceEcho?: Maybe<Scalars['Int']>;
  audioDeviceGain?: Maybe<Scalars['Int']>;
  audioDeviceNoise?: Maybe<Scalars['Int']>;
  billingType?: Maybe<Scalars['String']>;
  callerid?: Maybe<Scalars['String']>;
  calleridName?: Maybe<Scalars['String']>;
  canBeManaged?: Maybe<Scalars['Int']>;
  canCallCoach?: Maybe<Scalars['Int']>;
  capsuleUserName?: Maybe<Scalars['String']>;
  closedAction?: Maybe<Scalars['String']>;
  compactMode?: Maybe<Scalars['String']>;
  countrycode?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['AWSDateTime']>;
  defaultC2C?: Maybe<Scalars['String']>;
  defaultExtend?: Maybe<Scalars['Boolean']>;
  dispose?: Maybe<Scalars['Int']>;
  email: Scalars['String'];
  fname?: Maybe<Scalars['String']>;
  ftcBlocking?: Maybe<Scalars['Int']>;
  inPowerlistSession: Scalars['Int'];
  inactiveDate?: Maybe<Scalars['AWSDateTime']>;
  isactive?: Maybe<Scalars['Int']>;
  lname?: Maybe<Scalars['String']>;
  localPresenceLite?: Maybe<Scalars['Int']>;
  localPresenceOn?: Maybe<Scalars['Int']>;
  localPresenceProgressive?: Maybe<Scalars['Int']>;
  logLevel: Users_LogLevel;
  logUntil?: Maybe<Scalars['AWSDateTime']>;
  machineDetectionEnabled?: Maybe<Scalars['Boolean']>;
  mailServer?: Maybe<Scalars['String']>;
  mediaMetricsOn?: Maybe<Scalars['Int']>;
  newUser?: Maybe<Scalars['Int']>;
  orig_email?: Maybe<Scalars['String']>;
  othersCanViewRecordings?: Maybe<Scalars['Int']>;
  overrideDnc?: Maybe<Scalars['Boolean']>;
  pass2?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  playEndSound?: Maybe<Scalars['Int']>;
  playStartSound?: Maybe<Scalars['Int']>;
  pop?: Maybe<Scalars['Int']>;
  preferredServer?: Maybe<Scalars['String']>;
  ptype?: Maybe<Scalars['Int']>;
  quietMode: Scalars['Boolean'];
  recordCalls?: Maybe<Scalars['Int']>;
  sendRecordingtoCRM?: Maybe<Scalars['Int']>;
  setSuperadminPermissions?: Maybe<Scalars['Boolean']>;
  showDispostion?: Maybe<Scalars['Int']>;
  smsDID?: Maybe<Scalars['String']>;
  styleMode?: Maybe<Scalars['String']>;
  switchUser?: Maybe<Scalars['Boolean']>;
  systemTeamId?: Maybe<Scalars['Long']>;
  temp_password: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
  useBusinessHoursEnabled: Scalars['Boolean'];
  useCellService?: Maybe<Scalars['Int']>;
  userEXT?: Maybe<Scalars['Int']>;
  userHours?: Maybe<Scalars['AWSJSON']>;
  userTier?: Maybe<Scalars['String']>;
  userid: Scalars['Long'];
  userscol?: Maybe<Scalars['String']>;
  vmDropDetectionType?: Maybe<Scalars['String']>;
  webrtcAudio?: Maybe<Scalars['String']>;
  webrtcAudioLabel?: Maybe<Scalars['String']>;
  webrtcMic?: Maybe<Scalars['String']>;
  webrtcMicLabel?: Maybe<Scalars['String']>;
  webrtcRing?: Maybe<Scalars['String']>;
  webrtcRingLabel?: Maybe<Scalars['String']>;
};

export type UsersCount = {
  __typename?: 'UsersCount';
  cadenceProcess: Scalars['Int'];
  powerlist: Scalars['Int'];
  powerlistContact: Scalars['Int'];
  powerlistContact_powerlistContact_outcomeCreatedByTousers: Scalars['Int'];
  powerlistContact_powerlistContact_refresherCreatedByTousers: Scalars['Int'];
  powerlistSpreadsheet: Scalars['Int'];
  powerlistTeamUserSubscription: Scalars['Int'];
  powerlistUserSession: Scalars['Int'];
};

export enum UsersScalarFieldEnum {
  C2Con = 'C2Con',
  DidGreeting = 'DIDGreeting',
  DidNoActionAnswer = 'DIDNoActionAnswer',
  DidRingAudio = 'DIDRingAudio',
  Dnd = 'DND',
  Disposeon = 'Disposeon',
  FsCallFlowId = 'FSCallFlowID',
  FSuserId = 'FSuserID',
  FSvmId = 'FSvmID',
  LightModeon = 'LightModeon',
  PlivoUser = 'PlivoUser',
  PowerListEarliestCall = 'PowerListEarliestCall',
  PowerListLatestCall = 'PowerListLatestCall',
  AgentQueueEnabled = 'agentQueueEnabled',
  AllowMultipleIncomingCalls = 'allowMultipleIncomingCalls',
  AudioDeviceEcho = 'audioDeviceEcho',
  AudioDeviceGain = 'audioDeviceGain',
  AudioDeviceNoise = 'audioDeviceNoise',
  BillingType = 'billingType',
  Callerid = 'callerid',
  CalleridName = 'calleridName',
  CanBeManaged = 'canBeManaged',
  CanCallCoach = 'canCallCoach',
  CapsuleUserName = 'capsuleUserName',
  ClosedAction = 'closedAction',
  CompactMode = 'compactMode',
  Countrycode = 'countrycode',
  Created = 'created',
  DefaultC2C = 'defaultC2C',
  DefaultExtend = 'defaultExtend',
  Dispose = 'dispose',
  Email = 'email',
  Fname = 'fname',
  FtcBlocking = 'ftcBlocking',
  InPowerlistSession = 'inPowerlistSession',
  InactiveDate = 'inactiveDate',
  Isactive = 'isactive',
  Lname = 'lname',
  LocalPresenceLite = 'localPresenceLite',
  LocalPresenceOn = 'localPresenceOn',
  LocalPresenceProgressive = 'localPresenceProgressive',
  LogLevel = 'logLevel',
  LogUntil = 'logUntil',
  MachineDetectionEnabled = 'machineDetectionEnabled',
  MailServer = 'mailServer',
  MediaMetricsOn = 'mediaMetricsOn',
  NewUser = 'newUser',
  OrigEmail = 'orig_email',
  OthersCanViewRecordings = 'othersCanViewRecordings',
  OverrideDnc = 'overrideDnc',
  Pass2 = 'pass2',
  Password = 'password',
  PlayEndSound = 'playEndSound',
  PlayStartSound = 'playStartSound',
  Pop = 'pop',
  PreferredServer = 'preferredServer',
  Ptype = 'ptype',
  QuietMode = 'quietMode',
  RecordCalls = 'recordCalls',
  SendRecordingtoCrm = 'sendRecordingtoCRM',
  SetSuperadminPermissions = 'setSuperadminPermissions',
  ShowDispostion = 'showDispostion',
  SmsDid = 'smsDID',
  StyleMode = 'styleMode',
  SwitchUser = 'switchUser',
  SystemTeamId = 'systemTeamId',
  TempPassword = 'temp_password',
  Type = 'type',
  UseBusinessHoursEnabled = 'useBusinessHoursEnabled',
  UseCellService = 'useCellService',
  UserExt = 'userEXT',
  UserHours = 'userHours',
  UserTier = 'userTier',
  Userid = 'userid',
  Userscol = 'userscol',
  VmDropDetectionType = 'vmDropDetectionType',
  WebrtcAudio = 'webrtcAudio',
  WebrtcAudioLabel = 'webrtcAudioLabel',
  WebrtcMic = 'webrtcMic',
  WebrtcMicLabel = 'webrtcMicLabel',
  WebrtcRing = 'webrtcRing',
  WebrtcRingLabel = 'webrtcRingLabel',
}

export enum CadenceProcess_SmsSender {
  TeamSms = 'teamSMS',
  UseAgent = 'useAgent',
}

export enum CadenceProcess_Status {
  Completed = 'completed',
  Incomplete = 'incomplete',
  Processing = 'processing',
}

export enum CadenceProcess_Substatus {
  AlreadyEnrolled = 'alreadyEnrolled',
  CadenceInactive = 'cadenceInactive',
  Completed = 'completed',
  CouldNotBeScheduled = 'couldNotBeScheduled',
  Deleted = 'deleted',
  ForwardedDueToDispositionRule = 'forwardedDueToDispositionRule',
  ForwardedDueToRerouteRule = 'forwardedDueToRerouteRule',
  InvalidNumber = 'invalidNumber',
  NoAgentAvailableForOneWeek = 'noAgentAvailableForOneWeek',
  NoAgentsInQueue = 'noAgentsInQueue',
  RemovedByApi = 'removedByAPI',
  StoppedDueToDispositionRule = 'stoppedDueToDispositionRule',
  StoppedDueToRenrollment = 'stoppedDueToRenrollment',
  SystemError = 'systemError',
}

export enum Cadence_AssignContactOwner {
  AssignFromQueueOnAnswer = 'assignFromQueueOnAnswer',
  AutoAssignFromQueue = 'autoAssignFromQueue',
}

export enum Cadence_SmsSender {
  TeamSms = 'teamSMS',
  UseAgent = 'useAgent',
}

export enum Cadence_Status {
  Active = 'active',
  Deleted = 'deleted',
  Inactive = 'inactive',
}

export enum PowerlistContact_DeferredReason {
  MaxAttemptsPerDayReached = 'Max_Attempts_per_Day_Reached',
  MinDurationBetweenCallsApplied = 'Min__Duration_Between_Calls_Applied',
  ScheduledAsDoNotCallSoonerThan = 'Scheduled_as_Do_Not_Call_Sooner_Than',
  TargetPowerlistHoursApplied = 'Target_Powerlist_Hours_Applied',
}

export enum PowerlistContact_Status {
  AnsweredWaitingForOutcome = 'answeredWaitingForOutcome',
  Dequeue = 'dequeue',
  DequeueForwardToCadence = 'dequeueForwardToCadence',
  DequeueForwardToPowerlist = 'dequeueForwardToPowerlist',
  Dialing = 'dialing',
  Enqueue = 'enqueue',
  ErrorDialingNumber = 'errorDialingNumber',
  MaxAttemptsReached = 'maxAttemptsReached',
  Rescheduling = 'rescheduling',
  Reserved = 'reserved',
}

export enum PowerlistDispositionRule_Action {
  ForwardToCadence = 'forwardToCadence',
  ForwardToPowerlist = 'forwardToPowerlist',
  Remove = 'remove',
  SendSms = 'sendSMS',
}

export enum PowerlistDispositionRule_Status {
  Active = 'active',
  Deleted = 'deleted',
}

export enum PowerlistSpreadsheet_DuplicateHandling {
  Ignore = 'ignore',
  Merge = 'merge',
  Overwrite = 'overwrite',
}

export enum PowerlistSpreadsheet_Status {
  InvalidFormat = 'invalidFormat',
  ProcessingComplete = 'processingComplete',
  ProcessingSpreadsheet = 'processingSpreadsheet',
  WaitingToBeProcessed = 'waitingToBeProcessed',
}

export type PowerlistTeamInfo = {
  __typename?: 'powerlistTeamInfo';
  isSubscribed?: Maybe<Scalars['Int']>;
  powerlistTeamId?: Maybe<Scalars['Int']>;
  teamid?: Maybe<Scalars['Int']>;
  teamname?: Maybe<Scalars['String']>;
};

export enum PowerlistUserSession_Status {
  Created = 'created',
  Ended = 'ended',
  OnPause = 'onPause',
  Started = 'started',
}

export enum Powerlist_Status {
  Active = 'active',
  Deleted = 'deleted',
  Inactive = 'inactive',
}

export enum Users_LogLevel {
  All = 'all',
  Debug = 'debug',
  Error = 'error',
  Fatal = 'fatal',
  Info = 'info',
  Off = 'off',
  Trace = 'trace',
  Warn = 'warn',
}

export type CreateEventMutationVariables = Exact<{
  event: TEventInput;
  auth: TAuthInput;
}>;

export type CreateEventMutation = {
  __typename?: 'Mutation';
  createEvent?:
    | {
        __typename?: 'TEvent';
        id?: string | null | undefined;
        source?: ELocation | null | undefined;
        target?: ELocation | null | undefined;
        type?: EEventType | null | undefined;
        group?: EEventGroup | null | undefined;
        userId?: number | null | undefined;
        businessId?: number | null | undefined;
        payload?: string | null | undefined;
        topicId?: string | null | undefined;
      }
    | null
    | undefined;
};

export type SubscribePowerlistsMutationVariables = Exact<{
  userId: Scalars['Long'];
  subscribe: Scalars['Int'];
  powerlistIds: Array<Scalars['Int']> | Scalars['Int'];
}>;

export type SubscribePowerlistsMutation = {
  __typename?: 'Mutation';
  subscribePowerlists?:
    | {
        __typename?: 'TSubscribePowerlistsOutput';
        success?: boolean | null | undefined;
        exception?: string | null | undefined;
      }
    | null
    | undefined;
};

export type StartDialingMutationVariables = Exact<{
  userId: Scalars['Long'];
  businessId: Scalars['Int'];
}>;

export type StartDialingMutation = {
  __typename?: 'Mutation';
  startDialing?:
    | {
        __typename?: 'TPowerlistResponse';
        success?: boolean | null | undefined;
        errorMessage?: string | null | undefined;
        deferredData?:
          | Array<
              | {
                  __typename?: 'TPowerlistDeferredSummary';
                  powerlistName?: string | null | undefined;
                  summary?:
                    | Array<
                        | {
                            __typename?: 'TPowerlistDeferredReason';
                            reason?: string | null | undefined;
                            count?: number | null | undefined;
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DialCurrentPowerlistTargetMutationVariables = Exact<{
  sessionId: Scalars['Int'];
  userId: Scalars['Int'];
}>;

export type DialCurrentPowerlistTargetMutation = {
  __typename?: 'Mutation';
  dialCurrentPowerlistTarget?:
    | {
        __typename?: 'TPowerlistResponse';
        success?: boolean | null | undefined;
        errorMessage?: string | null | undefined;
      }
    | null
    | undefined;
};

export type PausePowerlistSessionMutationVariables = Exact<{
  userId: Scalars['Long'];
  sessionId: Scalars['Int'];
  businessId: Scalars['Int'];
}>;

export type PausePowerlistSessionMutation = {
  __typename?: 'Mutation';
  pausePowerlistSession?:
    | {
        __typename?: 'TPowerlistResponse';
        success?: boolean | null | undefined;
        errorMessage?: string | null | undefined;
      }
    | null
    | undefined;
};

export type ResumePowerlistSessionMutationVariables = Exact<{
  userId: Scalars['Long'];
  sessionId: Scalars['Int'];
  businessId: Scalars['Int'];
}>;

export type ResumePowerlistSessionMutation = {
  __typename?: 'Mutation';
  resumePowerlistSession?:
    | {
        __typename?: 'TPowerlistResponse';
        success?: boolean | null | undefined;
        errorMessage?: string | null | undefined;
        deferredData?:
          | Array<
              | {
                  __typename?: 'TPowerlistDeferredSummary';
                  powerlistName?: string | null | undefined;
                  summary?:
                    | Array<
                        | {
                            __typename?: 'TPowerlistDeferredReason';
                            reason?: string | null | undefined;
                            count?: number | null | undefined;
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ReservePowerlistContactsMutationVariables = Exact<{
  userId: Scalars['Long'];
  sessionId: Scalars['Int'];
}>;

export type ReservePowerlistContactsMutation = {
  __typename?: 'Mutation';
  reservePowerlistContacts?:
    | {
        __typename?: 'TPowerlistReserveContactResponse';
        success?: boolean | null | undefined;
        errorMessage?: string | null | undefined;
      }
    | null
    | undefined;
};

export type EndPowerlistSessionMutationVariables = Exact<{
  sessionId: Scalars['Int'];
}>;

export type EndPowerlistSessionMutation = {
  __typename?: 'Mutation';
  endPowerlistSession?:
    | {
        __typename?: 'TPowerlistResponse';
        success?: boolean | null | undefined;
        errorMessage?: string | null | undefined;
      }
    | null
    | undefined;
};

export type DialNextPowerlistMutationVariables = Exact<{
  sessionId: Scalars['Int'];
  userId: Scalars['Int'];
}>;

export type DialNextPowerlistMutation = {
  __typename?: 'Mutation';
  dialNextPowerlist?:
    | {
        __typename?: 'TPowerlistResponse';
        success?: boolean | null | undefined;
        errorMessage?: string | null | undefined;
        deferredData?:
          | Array<
              | {
                  __typename?: 'TPowerlistDeferredSummary';
                  powerlistName?: string | null | undefined;
                  summary?:
                    | Array<
                        | {
                            __typename?: 'TPowerlistDeferredReason';
                            reason?: string | null | undefined;
                            count?: number | null | undefined;
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type SaveOutcomePowerlistMutationVariables = Exact<{
  userId: Scalars['Long'];
  callId: Scalars['Int'];
  powerlistId: Scalars['Int'];
  powerlistContactId: Scalars['Int'];
  nextCallRefresher: Scalars['String'];
  refresherCreatedBy: Scalars['Int'];
  refesherUpdateDateTime: Scalars['String'];
  outcome?: Maybe<Scalars['String']>;
  outcomeCreatedBy?: Maybe<Scalars['Int']>;
  outcomeUpdateDateTime?: Maybe<Scalars['String']>;
  smsTemplate?: Maybe<Scalars['String']>;
  nextAppointment?: Maybe<Scalars['String']>;
  dispositionId: Scalars['Int'];
  externalCallId: Scalars['String'];
}>;

export type SaveOutcomePowerlistMutation = {
  __typename?: 'Mutation';
  saveOutcomePowerlist?:
    | {
        __typename?: 'TSaveOutcomeOutput';
        success?: boolean | null | undefined;
        errorMessage?: string | null | undefined;
      }
    | null
    | undefined;
};

export type ReschedulePowerlistContactMutationVariables = Exact<{
  powerlistContactId: Scalars['Int'];
}>;

export type ReschedulePowerlistContactMutation = {
  __typename?: 'Mutation';
  reschedulePowerlistContact?:
    | {
        __typename?: 'TReschedulePowerlistContactOutput';
        success?: boolean | null | undefined;
        errorMessage?: string | null | undefined;
      }
    | null
    | undefined;
};

export type DeletePowerlistContactMutationVariables = Exact<{
  powerlistContactId: Scalars['Int'];
}>;

export type DeletePowerlistContactMutation = {
  __typename?: 'Mutation';
  deletePowerlistContact?:
    | {
        __typename?: 'TDeletePowerlistContactOutput';
        success?: boolean | null | undefined;
        errorMessage?: string | null | undefined;
      }
    | null
    | undefined;
};

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  source: ELocation;
}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  login?:
    | {
        __typename?: 'TAllSettings';
        loginSettings?:
          | {
              __typename?: 'TLoginSettings';
              C2Con: boolean;
              DIDGreeting?: string | null | undefined;
              DIDNoActionAnswer?: string | null | undefined;
              DIDRingAudio?: string | null | undefined;
              DND: boolean;
              Disposeon: boolean;
              FSCallFlowID?: string | null | undefined;
              FSuserID?: string | null | undefined;
              FSvmID?: string | null | undefined;
              LightModeon: boolean;
              PlivoUser: boolean;
              PowerListEarliestCall: number;
              PowerListLatestCall: number;
              allowMultipleIncomingCalls: boolean;
              audioDeviceEcho: boolean;
              audioDeviceGain: boolean;
              audioDeviceNoise: boolean;
              billingType?: string | null | undefined;
              callerid: string;
              calleridName: string;
              canBeManaged: boolean;
              canCallCoach: boolean;
              canCallCoach2: boolean;
              capsuleUserName?: string | null | undefined;
              cellCC?: string | null | undefined;
              cellNumber?: string | null | undefined;
              closedAction?: string | null | undefined;
              compactMode?: string | null | undefined;
              countrycode: string;
              created?: string | null | undefined;
              defaultC2C?: string | null | undefined;
              defaultExtend?: boolean | null | undefined;
              dispose: boolean;
              email: string;
              fname?: string | null | undefined;
              ftcBlocking: boolean;
              hasCell?: boolean | null | undefined;
              inPowerlistSession: boolean;
              inactiveDate?: string | null | undefined;
              isactive?: boolean | null | undefined;
              lname?: string | null | undefined;
              localPresenceLite: boolean;
              localPresenceOn: boolean;
              localPresenceProgressive: boolean;
              mediaMetricsOn: boolean;
              newUser: boolean;
              orig_email?: string | null | undefined;
              othersCanViewRecordings: boolean;
              overrideDnc: boolean;
              pass2?: string | null | undefined;
              password?: string | null | undefined;
              playEndSound: boolean;
              playStartSound: boolean;
              pop: boolean;
              preferredServer: string;
              ptype?: number | null | undefined;
              quietMode: boolean;
              recordCalls: boolean;
              sendRecordingtoCRM: boolean;
              setSuperadminPermissions: boolean;
              showDispostion: boolean;
              smsDID?: string | null | undefined;
              styleMode?: string | null | undefined;
              switchUser: boolean;
              type: ERole;
              temp_password?: number | null | undefined;
              useBusinessHoursEnabled: boolean;
              useCellService: boolean;
              userEXT: number;
              userHours?: string | null | undefined;
              userTier: string;
              userid: number;
              userscol?: string | null | undefined;
              vmDropDetectionType?: string | null | undefined;
              webrtcAudio?: string | null | undefined;
              webrtcAudioLabel?: string | null | undefined;
              webrtcMic?: string | null | undefined;
              webrtcMicLabel?: string | null | undefined;
              webrtcRing?: string | null | undefined;
              webrtcRingLabel?: string | null | undefined;
              systemTeamId?: number | null | undefined;
              devices?:
                | Array<
                    | {
                        __typename?: 'TDevice';
                        sipUserId?: number | null | undefined;
                        userId: number;
                        sipAddress?: string | null | undefined;
                        deviceType?: string | null | undefined;
                        DID?: string | null | undefined;
                        createdate?: string | null | undefined;
                        updatedate?: string | null | undefined;
                        deviceid?: string | null | undefined;
                        zohoUserId?: string | null | undefined;
                        deviceName?: string | null | undefined;
                        phoneType?: string | null | undefined;
                        ext?: number | null | undefined;
                        cred?: string | null | undefined;
                        endpointid?: string | null | undefined;
                        didCountryCode?: string | null | undefined;
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined;
              defaultDevice?:
                | {
                    __typename?: 'TDefaultDevice';
                    defaultC2C?: string | null | undefined;
                    deviceType?: string | null | undefined;
                    deviceName?: string | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        userSettings?:
          | {
              __typename?: 'TUserSettings';
              allowAgentPowerlist?: boolean | null | undefined;
              accessToken: string;
              apikey: string;
              businessId: number;
              callRecord: boolean;
              canBeManaged: boolean;
              canCallCoach: boolean;
              canDeleteUsers: boolean;
              cardDeclined: boolean;
              email: string;
              hasBilling: boolean;
              inTrial: boolean;
              logLevel?: ELogLevel | null | undefined;
              onlyManagersCanAddPhoneNumbers: boolean;
              onlyManagersCanViewCallReporting: boolean;
              refreshToken: string;
              role: ERole;
              tier: string;
              trialExpired: boolean;
              userid: number;
              expiresInTimestamp: number;
              timezone?: string | null | undefined;
            }
          | null
          | undefined;
        userProducts?:
          | Array<
              | {
                  __typename?: 'TUserProducts';
                  businessproductid: number;
                  businessid: number;
                  startdate?: string | null | undefined;
                  enddate?: string | null | undefined;
                  productid: number;
                  includedunits?: number | null | undefined;
                  priceperunit?: number | null | undefined;
                  units?: number | null | undefined;
                  status?: string | null | undefined;
                  userid?: number | null | undefined;
                  numberid?: number | null | undefined;
                  agentSeat?: number | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type Login2MutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  source: ELocation;
}>;

export type Login2Mutation = {
  __typename?: 'Mutation';
  login2?:
    | {
        __typename?: 'TAllSettings';
        loginSettings?:
          | {
              __typename?: 'TLoginSettings';
              C2Con: boolean;
              DIDGreeting?: string | null | undefined;
              DIDNoActionAnswer?: string | null | undefined;
              DIDRingAudio?: string | null | undefined;
              DND: boolean;
              Disposeon: boolean;
              FSCallFlowID?: string | null | undefined;
              FSuserID?: string | null | undefined;
              FSvmID?: string | null | undefined;
              LightModeon: boolean;
              PlivoUser: boolean;
              PowerListEarliestCall: number;
              PowerListLatestCall: number;
              allowMultipleIncomingCalls: boolean;
              audioDeviceEcho: boolean;
              audioDeviceGain: boolean;
              audioDeviceNoise: boolean;
              billingType?: string | null | undefined;
              callerid: string;
              calleridName: string;
              canBeManaged: boolean;
              canCallCoach: boolean;
              canCallCoach2: boolean;
              capsuleUserName?: string | null | undefined;
              cellCC?: string | null | undefined;
              cellNumber?: string | null | undefined;
              closedAction?: string | null | undefined;
              compactMode?: string | null | undefined;
              countrycode: string;
              created?: string | null | undefined;
              defaultC2C?: string | null | undefined;
              defaultExtend?: boolean | null | undefined;
              dispose: boolean;
              email: string;
              fname?: string | null | undefined;
              ftcBlocking: boolean;
              hasCell?: boolean | null | undefined;
              inPowerlistSession: boolean;
              inactiveDate?: string | null | undefined;
              isactive?: boolean | null | undefined;
              lname?: string | null | undefined;
              localPresenceLite: boolean;
              localPresenceOn: boolean;
              localPresenceProgressive: boolean;
              mediaMetricsOn: boolean;
              newUser: boolean;
              orig_email?: string | null | undefined;
              othersCanViewRecordings: boolean;
              overrideDnc: boolean;
              pass2?: string | null | undefined;
              password?: string | null | undefined;
              playEndSound: boolean;
              playStartSound: boolean;
              pop: boolean;
              preferredServer: string;
              ptype?: number | null | undefined;
              quietMode: boolean;
              recordCalls: boolean;
              sendRecordingtoCRM: boolean;
              setSuperadminPermissions: boolean;
              showDispostion: boolean;
              smsDID?: string | null | undefined;
              styleMode?: string | null | undefined;
              switchUser: boolean;
              type: ERole;
              temp_password?: number | null | undefined;
              useBusinessHoursEnabled: boolean;
              useCellService: boolean;
              userEXT: number;
              userHours?: string | null | undefined;
              userTier: string;
              userid: number;
              userscol?: string | null | undefined;
              vmDropDetectionType?: string | null | undefined;
              webrtcAudio?: string | null | undefined;
              webrtcAudioLabel?: string | null | undefined;
              webrtcMic?: string | null | undefined;
              webrtcMicLabel?: string | null | undefined;
              webrtcRing?: string | null | undefined;
              webrtcRingLabel?: string | null | undefined;
              systemTeamId?: number | null | undefined;
              devices?:
                | Array<
                    | {
                        __typename?: 'TDevice';
                        sipUserId?: number | null | undefined;
                        userId: number;
                        sipAddress?: string | null | undefined;
                        deviceType?: string | null | undefined;
                        DID?: string | null | undefined;
                        createdate?: string | null | undefined;
                        updatedate?: string | null | undefined;
                        deviceid?: string | null | undefined;
                        zohoUserId?: string | null | undefined;
                        deviceName?: string | null | undefined;
                        phoneType?: string | null | undefined;
                        ext?: number | null | undefined;
                        cred?: string | null | undefined;
                        endpointid?: string | null | undefined;
                        didCountryCode?: string | null | undefined;
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined;
              defaultDevice?:
                | {
                    __typename?: 'TDefaultDevice';
                    defaultC2C?: string | null | undefined;
                    deviceType?: string | null | undefined;
                    deviceName?: string | null | undefined;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        userSettings?:
          | {
              __typename?: 'TUserSettings';
              allowAgentPowerlist?: boolean | null | undefined;
              accessToken: string;
              apikey: string;
              businessId: number;
              callRecord: boolean;
              canBeManaged: boolean;
              canCallCoach: boolean;
              canDeleteUsers: boolean;
              cardDeclined: boolean;
              email: string;
              hasBilling: boolean;
              inTrial: boolean;
              logLevel?: ELogLevel | null | undefined;
              onlyManagersCanAddPhoneNumbers: boolean;
              onlyManagersCanViewCallReporting: boolean;
              refreshToken: string;
              role: ERole;
              tier: string;
              trialExpired: boolean;
              userid: number;
              expiresInTimestamp: number;
              timezone?: string | null | undefined;
            }
          | null
          | undefined;
        userProducts?:
          | Array<
              | {
                  __typename?: 'TUserProducts';
                  businessproductid: number;
                  businessid: number;
                  startdate?: string | null | undefined;
                  enddate?: string | null | undefined;
                  productid: number;
                  includedunits?: number | null | undefined;
                  priceperunit?: number | null | undefined;
                  units?: number | null | undefined;
                  status?: string | null | undefined;
                  userid?: number | null | undefined;
                  numberid?: number | null | undefined;
                  agentSeat?: number | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetReservedContactsQueryVariables = Exact<{
  powerlistUserSessionId?: Maybe<Scalars['Int']>;
  userid?: Maybe<Scalars['Long']>;
  powerlistId?: Maybe<Scalars['Int']>;
}>;

export type GetReservedContactsQuery = {
  __typename?: 'Query';
  getReservedContacts?:
    | Array<
        | {
            __typename?: 'TReservedContactsOutput';
            mustDespositionCalls?: number | null | undefined;
            powerlistContactId: number;
            powerlistId: number;
            powerlistSpreadsheetId?: number | null | undefined;
            status: PowerlistContact_Status;
            rowNumber?: number | null | undefined;
            phoneNumber: string;
            phoneNumber164: string;
            email?: string | null | undefined;
            firstName?: string | null | undefined;
            lastName?: string | null | undefined;
            title?: string | null | undefined;
            targetTimeZone: string;
            attemptCount: number;
            lastAttemptDateTime?: string | null | undefined;
            retryAfterDateTime?: string | null | undefined;
            ownerUserId?: number | null | undefined;
            reservedForUserId?: number | null | undefined;
            powerlistName?: string | null | undefined;
            companyName?: string | null | undefined;
            nextCallRefresher?: string | null | undefined;
            refresherCreatedBy?: number | null | undefined;
            refesherUpdateDateTime?: string | null | undefined;
            ssData?: string | null | undefined;
            refresherCreatedByName?: string | null | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type GetPowerlistUserSessionQueryVariables = Exact<{
  userid?: Maybe<Scalars['Long']>;
  powerlistUserSessionId?: Maybe<Scalars['Int']>;
  accessToken?: Maybe<Scalars['String']>;
  businessId?: Maybe<Scalars['Long']>;
}>;

export type GetPowerlistUserSessionQuery = {
  __typename?: 'Query';
  getPowerlistUserSession?:
    | {
        __typename?: 'TPowerlistUserSessionOutput';
        success?: boolean | null | undefined;
        errorMessage?: string | null | undefined;
        data?:
          | {
              __typename?: 'PowerlistUserSession';
              curPowerlistId?: number | null | undefined;
              status: PowerlistUserSession_Status;
              statusIntervals: string;
              userId: number;
              powerlistUserSessionId: number;
              statDialed: number;
              statAnswered: number;
              statConnected: number;
              statTalkTimeInSec: number;
              sessionEndDateTime?: string | null | undefined;
              sessionStartDateTime?: string | null | undefined;
              sessionCreateDateTime: string;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type GetPowerlistWithTeamByUserIdQueryVariables = Exact<{
  userid?: Maybe<Scalars['Long']>;
}>;

export type GetPowerlistWithTeamByUserIdQuery = {
  __typename?: 'Query';
  getPowerlistWithTeamByUserId?:
    | Array<
        | {
            __typename?: 'TGetPowerlistWithTeamByUserIdOutput';
            powerlistId?: number | null | undefined;
            businessId?: number | null | undefined;
            name?: string | null | undefined;
            status?: string | null | undefined;
            autostartOnLogon?: number | null | undefined;
            mustDespositionCalls?: number | null | undefined;
            hangupOnMachineAnswers?: number | null | undefined;
            assignToAgentOnAnswer?: number | null | undefined;
            overrideOwnerOnAnswer?: number | null | undefined;
            onlyDialFromOwnerIfOwned?: number | null | undefined;
            secondsBeforeTimeout?: number | null | undefined;
            maxAttempts?: number | null | undefined;
            dialAtATime?: number | null | undefined;
            maxAttemptsPerDay?: number | null | undefined;
            minDurationBeforeCallRetyInMin?: number | null | undefined;
            maxWaitAfterCallInSec?: number | null | undefined;
            powerlistHours?: string | null | undefined;
            useBusinessHoursForPowerlist?: number | null | undefined;
            targetHours?: string | null | undefined;
            useBusinessHoursForTarget?: number | null | undefined;
            maxSmsPerTemplateCount?: number | null | undefined;
            maxSmsPerTemplateDurationInMin?: number | null | undefined;
            createdByUserId?: number | null | undefined;
            updatedDate?: string | null | undefined;
            createdDate?: string | null | undefined;
            powerlistTeamId?: number | null | undefined;
            powerlistPriority?: number | null | undefined;
            teamInfo?: string | null | undefined;
            userid?: number | null | undefined;
            email?: string | null | undefined;
            fname?: string | null | undefined;
            lname?: string | null | undefined;
            isSubscribed?: number | null | undefined;
            isAgentPowerlist?: number | null | undefined;
            statDialed?: number | null | undefined;
            statAnswered?: number | null | undefined;
            statConnected?: number | null | undefined;
            statTalkTimeInSec?: number | null | undefined;
            countQueued?: number | null | undefined;
            countDeferred?: number | null | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type DirectoryQueryVariables = Exact<{
  apikey?: Maybe<Scalars['String']>;
  businessId?: Maybe<Scalars['Long']>;
}>;

export type DirectoryQuery = {
  __typename?: 'Query';
  directory?:
    | Array<
        | {
            __typename?: 'TDirectoryOutput';
            DND?: number | null | undefined;
            b: string;
            callStart?: string | null | undefined;
            canBeManaged?: number | null | undefined;
            canCallCoach?: number | null | undefined;
            confName?: string | null | undefined;
            crmlink?: string | null | undefined;
            customerName?: string | null | undefined;
            customerNumber?: string | null | undefined;
            data?: string | null | undefined;
            direction?: string | null | undefined;
            ext?: number | null | undefined;
            externalid?: string | null | undefined;
            loggedin?: number | null | undefined;
            name?: string | null | undefined;
            oncall?: number | null | undefined;
            u: string;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type ConnectionQueryVariables = Exact<{ [key: string]: never }>;

export type ConnectionQuery = {
  __typename?: 'Query';
  connection: {
    __typename?: 'TConnection';
    originUrl: string;
    apiKey: string;
    region: string;
    color: EColor;
    nodeEnv: ENodeEnv;
    deployVersion: string;
  };
};

export type Connection2QueryVariables = Exact<{ [key: string]: never }>;

export type Connection2Query = {
  __typename?: 'Query';
  connection2: {
    __typename?: 'TConnection';
    originUrl: string;
    apiKey: string;
    region: string;
    color: EColor;
    nodeEnv: ENodeEnv;
    deployVersion: string;
  };
};

export type OnCreateEventSubscriptionVariables = Exact<{
  group?: Maybe<EEventGroup>;
  target?: Maybe<ELocation>;
  userId?: Maybe<Scalars['Long']>;
  businessId?: Maybe<Scalars['Long']>;
  topicId?: Maybe<Scalars['String']>;
}>;

export type OnCreateEventSubscription = {
  __typename?: 'Subscription';
  onCreateEvent?:
    | {
        __typename?: 'TEvent';
        id?: string | null | undefined;
        source?: ELocation | null | undefined;
        target?: ELocation | null | undefined;
        type?: EEventType | null | undefined;
        group?: EEventGroup | null | undefined;
        userId?: number | null | undefined;
        businessId?: number | null | undefined;
        payload?: string | null | undefined;
        topicId?: string | null | undefined;
      }
    | null
    | undefined;
};

export const CreateEventDocument = `
    mutation CreateEvent($event: TEventInput!, $auth: TAuthInput!) {
  createEvent(event: $event, auth: $auth) {
    id
    source
    target
    type
    group
    userId
    businessId
    payload
    topicId
  }
}
    `;
export const SubscribePowerlistsDocument = `
    mutation SubscribePowerlists($userId: Long!, $subscribe: Int!, $powerlistIds: [Int!]!) {
  subscribePowerlists(
    userId: $userId
    subscribe: $subscribe
    powerlistIds: $powerlistIds
  ) {
    success
    exception
  }
}
    `;
export const StartDialingDocument = `
    mutation StartDialing($userId: Long!, $businessId: Int!) {
  startDialing(userId: $userId, businessId: $businessId) {
    success
    errorMessage
    deferredData {
      powerlistName
      summary {
        reason
        count
      }
    }
  }
}
    `;
export const DialCurrentPowerlistTargetDocument = `
    mutation DialCurrentPowerlistTarget($sessionId: Int!, $userId: Int!) {
  dialCurrentPowerlistTarget(sessionId: $sessionId, userId: $userId) {
    success
    errorMessage
  }
}
    `;
export const PausePowerlistSessionDocument = `
    mutation PausePowerlistSession($userId: Long!, $sessionId: Int!, $businessId: Int!) {
  pausePowerlistSession(
    userId: $userId
    sessionId: $sessionId
    businessId: $businessId
  ) {
    success
    errorMessage
  }
}
    `;
export const ResumePowerlistSessionDocument = `
    mutation ResumePowerlistSession($userId: Long!, $sessionId: Int!, $businessId: Int!) {
  resumePowerlistSession(
    userId: $userId
    sessionId: $sessionId
    businessId: $businessId
  ) {
    success
    errorMessage
    deferredData {
      powerlistName
      summary {
        reason
        count
      }
    }
  }
}
    `;
export const ReservePowerlistContactsDocument = `
    mutation ReservePowerlistContacts($userId: Long!, $sessionId: Int!) {
  reservePowerlistContacts(userId: $userId, sessionId: $sessionId) {
    success
    errorMessage
  }
}
    `;
export const EndPowerlistSessionDocument = `
    mutation EndPowerlistSession($sessionId: Int!) {
  endPowerlistSession(sessionId: $sessionId) {
    success
    errorMessage
  }
}
    `;
export const DialNextPowerlistDocument = `
    mutation DialNextPowerlist($sessionId: Int!, $userId: Int!) {
  dialNextPowerlist(sessionId: $sessionId, userId: $userId) {
    success
    errorMessage
    deferredData {
      powerlistName
      summary {
        reason
        count
      }
    }
  }
}
    `;
export const SaveOutcomePowerlistDocument = `
    mutation SaveOutcomePowerlist($userId: Long!, $callId: Int!, $powerlistId: Int!, $powerlistContactId: Int!, $nextCallRefresher: String!, $refresherCreatedBy: Int!, $refesherUpdateDateTime: String!, $outcome: String, $outcomeCreatedBy: Int, $outcomeUpdateDateTime: String, $smsTemplate: String, $nextAppointment: String, $dispositionId: Int!, $externalCallId: String!) {
  saveOutcomePowerlist(
    userId: $userId
    callId: $callId
    powerlistId: $powerlistId
    powerlistContactId: $powerlistContactId
    nextCallRefresher: $nextCallRefresher
    refresherCreatedBy: $refresherCreatedBy
    refesherUpdateDateTime: $refesherUpdateDateTime
    outcome: $outcome
    outcomeCreatedBy: $outcomeCreatedBy
    outcomeUpdateDateTime: $outcomeUpdateDateTime
    smsTemplate: $smsTemplate
    nextAppointment: $nextAppointment
    dispositionId: $dispositionId
    externalCallId: $externalCallId
  ) {
    success
    errorMessage
  }
}
    `;
export const ReschedulePowerlistContactDocument = `
    mutation ReschedulePowerlistContact($powerlistContactId: Int!) {
  reschedulePowerlistContact(powerlistContactId: $powerlistContactId) {
    success
    errorMessage
  }
}
    `;
export const DeletePowerlistContactDocument = `
    mutation DeletePowerlistContact($powerlistContactId: Int!) {
  deletePowerlistContact(powerlistContactId: $powerlistContactId) {
    success
    errorMessage
  }
}
    `;
export const LoginDocument = `
    mutation Login($email: String!, $password: String!, $source: ELocation!) {
  login(email: $email, password: $password, source: $source) {
    loginSettings {
      C2Con
      DIDGreeting
      DIDNoActionAnswer
      DIDRingAudio
      DND
      Disposeon
      FSCallFlowID
      FSuserID
      FSvmID
      LightModeon
      PlivoUser
      PowerListEarliestCall
      PowerListLatestCall
      allowMultipleIncomingCalls
      audioDeviceEcho
      audioDeviceGain
      audioDeviceNoise
      billingType
      callerid
      calleridName
      canBeManaged
      canCallCoach
      canCallCoach2
      capsuleUserName
      cellCC
      cellNumber
      closedAction
      compactMode
      countrycode
      created
      defaultC2C
      defaultExtend
      dispose
      email
      fname
      ftcBlocking
      hasCell
      inPowerlistSession
      inactiveDate
      isactive
      lname
      localPresenceLite
      localPresenceOn
      localPresenceProgressive
      mediaMetricsOn
      newUser
      orig_email
      othersCanViewRecordings
      overrideDnc
      pass2
      password
      playEndSound
      playStartSound
      pop
      preferredServer
      ptype
      quietMode
      recordCalls
      sendRecordingtoCRM
      setSuperadminPermissions
      showDispostion
      smsDID
      styleMode
      switchUser
      type
      temp_password
      useBusinessHoursEnabled
      useCellService
      userEXT
      userHours
      userTier
      userid
      userscol
      vmDropDetectionType
      webrtcAudio
      webrtcAudioLabel
      webrtcMic
      webrtcMicLabel
      webrtcRing
      webrtcRingLabel
      systemTeamId
      devices {
        sipUserId
        userId
        sipAddress
        deviceType
        DID
        createdate
        updatedate
        deviceid
        zohoUserId
        deviceName
        phoneType
        ext
        cred
        endpointid
        didCountryCode
      }
      defaultDevice {
        defaultC2C
        deviceType
        deviceName
      }
    }
    userSettings {
      allowAgentPowerlist
      accessToken
      apikey
      businessId
      callRecord
      canBeManaged
      canCallCoach
      canDeleteUsers
      cardDeclined
      email
      hasBilling
      inTrial
      logLevel
      onlyManagersCanAddPhoneNumbers
      onlyManagersCanViewCallReporting
      refreshToken
      role
      tier
      trialExpired
      userid
      expiresInTimestamp
      timezone
      machineDetectionEnabled
    }
    userProducts {
      businessproductid
      businessid
      startdate
      enddate
      productid
      includedunits
      priceperunit
      units
      status
      userid
      numberid
      agentSeat
    }
  }
}
    `;
export const Login2Document = `
    mutation Login2($email: String!, $password: String!, $source: ELocation!) {
  login2(email: $email, password: $password, source: $source) {
    loginSettings {
      C2Con
      DIDGreeting
      DIDNoActionAnswer
      DIDRingAudio
      DND
      Disposeon
      FSCallFlowID
      FSuserID
      FSvmID
      LightModeon
      PlivoUser
      PowerListEarliestCall
      PowerListLatestCall
      allowMultipleIncomingCalls
      audioDeviceEcho
      audioDeviceGain
      audioDeviceNoise
      billingType
      callerid
      calleridName
      canBeManaged
      canCallCoach
      canCallCoach2
      capsuleUserName
      cellCC
      cellNumber
      closedAction
      compactMode
      countrycode
      created
      defaultC2C
      defaultExtend
      dispose
      email
      fname
      ftcBlocking
      hasCell
      inPowerlistSession
      inactiveDate
      isactive
      lname
      localPresenceLite
      localPresenceOn
      localPresenceProgressive
      mediaMetricsOn
      newUser
      orig_email
      othersCanViewRecordings
      overrideDnc
      pass2
      password
      playEndSound
      playStartSound
      pop
      preferredServer
      ptype
      quietMode
      recordCalls
      sendRecordingtoCRM
      setSuperadminPermissions
      showDispostion
      smsDID
      styleMode
      switchUser
      type
      temp_password
      useBusinessHoursEnabled
      useCellService
      userEXT
      userHours
      userTier
      userid
      userscol
      vmDropDetectionType
      webrtcAudio
      webrtcAudioLabel
      webrtcMic
      webrtcMicLabel
      webrtcRing
      webrtcRingLabel
      systemTeamId
      devices {
        sipUserId
        userId
        sipAddress
        deviceType
        DID
        createdate
        updatedate
        deviceid
        zohoUserId
        deviceName
        phoneType
        ext
        cred
        endpointid
        didCountryCode
      }
      defaultDevice {
        defaultC2C
        deviceType
        deviceName
      }
    }
    userSettings {
      allowAgentPowerlist
      accessToken
      apikey
      businessId
      callRecord
      canBeManaged
      canCallCoach
      canDeleteUsers
      cardDeclined
      email
      hasBilling
      inTrial
      logLevel
      onlyManagersCanAddPhoneNumbers
      onlyManagersCanViewCallReporting
      refreshToken
      role
      tier
      trialExpired
      userid
      expiresInTimestamp
      timezone
      machineDetectionEnabled
    }
    userProducts {
      businessproductid
      businessid
      startdate
      enddate
      productid
      includedunits
      priceperunit
      units
      status
      userid
      numberid
      agentSeat
    }
  }
}
    `;
export const GetReservedContactsDocument = `
    query GetReservedContacts($powerlistUserSessionId: Int, $userid: Long, $powerlistId: Int) {
  getReservedContacts(
    powerlistUserSessionId: $powerlistUserSessionId
    userid: $userid
    powerlistId: $powerlistId
  ) {
    mustDespositionCalls
    powerlistContactId
    powerlistId
    powerlistSpreadsheetId
    status
    rowNumber
    phoneNumber
    phoneNumber164
    email
    firstName
    lastName
    title
    targetTimeZone
    attemptCount
    lastAttemptDateTime
    retryAfterDateTime
    ownerUserId
    reservedForUserId
    powerlistName
    companyName
    nextCallRefresher
    refresherCreatedBy
    refesherUpdateDateTime
    ssData
    refresherCreatedByName
  }
}
    `;
export const GetPowerlistUserSessionDocument = `
    query GetPowerlistUserSession($userid: Long, $powerlistUserSessionId: Int, $accessToken: String, $businessId: Long) {
  getPowerlistUserSession(
    userid: $userid
    powerlistUserSessionId: $powerlistUserSessionId
    accessToken: $accessToken
    businessId: $businessId
  ) {
    success
    data {
      curPowerlistId
      status
      statusIntervals
      userId
      powerlistUserSessionId
      statDialed
      statAnswered
      statConnected
      statTalkTimeInSec
      sessionEndDateTime
      sessionStartDateTime
      sessionCreateDateTime
    }
    errorMessage
  }
}
    `;
export const GetPowerlistWithTeamByUserIdDocument = `
    query GetPowerlistWithTeamByUserId($userid: Long) {
  getPowerlistWithTeamByUserId(userid: $userid) {
    powerlistId
    businessId
    name
    status
    autostartOnLogon
    mustDespositionCalls
    hangupOnMachineAnswers
    assignToAgentOnAnswer
    overrideOwnerOnAnswer
    onlyDialFromOwnerIfOwned
    secondsBeforeTimeout
    maxAttempts
    dialAtATime
    maxAttemptsPerDay
    minDurationBeforeCallRetyInMin
    maxWaitAfterCallInSec
    powerlistHours
    useBusinessHoursForPowerlist
    targetHours
    useBusinessHoursForTarget
    maxSmsPerTemplateCount
    maxSmsPerTemplateDurationInMin
    createdByUserId
    updatedDate
    createdDate
    powerlistTeamId
    powerlistPriority
    teamInfo
    userid
    email
    fname
    lname
    isSubscribed
    isAgentPowerlist
    statDialed
    statAnswered
    statConnected
    statTalkTimeInSec
    countQueued
    countDeferred
  }
}
    `;
export const DirectoryDocument = `
    query Directory($apikey: String, $businessId: Long) {
  directory(apikey: $apikey, businessId: $businessId) {
    DND
    b
    callStart
    canBeManaged
    canCallCoach
    confName
    crmlink
    customerName
    customerNumber
    data
    direction
    ext
    externalid
    loggedin
    name
    oncall
    u
  }
}
    `;
export const ConnectionDocument = `
    query Connection {
  connection {
    originUrl
    apiKey
    region
    color
    nodeEnv
    deployVersion
  }
}
    `;
export const Connection2Document = `
    query Connection2 {
  connection2 {
    originUrl
    apiKey
    region
    color
    nodeEnv
    deployVersion
  }
}
    `;
export const OnCreateEventDocument = `
    subscription OnCreateEvent($group: EEventGroup, $target: ELocation, $userId: Long, $businessId: Long, $topicId: String) {
  onCreateEvent(
    group: $group
    target: $target
    userId: $userId
    businessId: $businessId
    topicId: $topicId
  ) {
    id
    source
    target
    type
    group
    userId
    businessId
    payload
    topicId
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    CreateEvent: build.mutation<
      CreateEventMutation,
      CreateEventMutationVariables
    >({
      query: (variables) => ({ document: CreateEventDocument, variables }),
    }),
    SubscribePowerlists: build.mutation<
      SubscribePowerlistsMutation,
      SubscribePowerlistsMutationVariables
    >({
      query: (variables) => ({
        document: SubscribePowerlistsDocument,
        variables,
      }),
    }),
    StartDialing: build.mutation<
      StartDialingMutation,
      StartDialingMutationVariables
    >({
      query: (variables) => ({ document: StartDialingDocument, variables }),
    }),
    DialCurrentPowerlistTarget: build.mutation<
      DialCurrentPowerlistTargetMutation,
      DialCurrentPowerlistTargetMutationVariables
    >({
      query: (variables) => ({
        document: DialCurrentPowerlistTargetDocument,
        variables,
      }),
    }),
    PausePowerlistSession: build.mutation<
      PausePowerlistSessionMutation,
      PausePowerlistSessionMutationVariables
    >({
      query: (variables) => ({
        document: PausePowerlistSessionDocument,
        variables,
      }),
    }),
    ResumePowerlistSession: build.mutation<
      ResumePowerlistSessionMutation,
      ResumePowerlistSessionMutationVariables
    >({
      query: (variables) => ({
        document: ResumePowerlistSessionDocument,
        variables,
      }),
    }),
    ReservePowerlistContacts: build.mutation<
      ReservePowerlistContactsMutation,
      ReservePowerlistContactsMutationVariables
    >({
      query: (variables) => ({
        document: ReservePowerlistContactsDocument,
        variables,
      }),
    }),
    EndPowerlistSession: build.mutation<
      EndPowerlistSessionMutation,
      EndPowerlistSessionMutationVariables
    >({
      query: (variables) => ({
        document: EndPowerlistSessionDocument,
        variables,
      }),
    }),
    DialNextPowerlist: build.mutation<
      DialNextPowerlistMutation,
      DialNextPowerlistMutationVariables
    >({
      query: (variables) => ({
        document: DialNextPowerlistDocument,
        variables,
      }),
    }),
    SaveOutcomePowerlist: build.mutation<
      SaveOutcomePowerlistMutation,
      SaveOutcomePowerlistMutationVariables
    >({
      query: (variables) => ({
        document: SaveOutcomePowerlistDocument,
        variables,
      }),
    }),
    ReschedulePowerlistContact: build.mutation<
      ReschedulePowerlistContactMutation,
      ReschedulePowerlistContactMutationVariables
    >({
      query: (variables) => ({
        document: ReschedulePowerlistContactDocument,
        variables,
      }),
    }),
    DeletePowerlistContact: build.mutation<
      DeletePowerlistContactMutation,
      DeletePowerlistContactMutationVariables
    >({
      query: (variables) => ({
        document: DeletePowerlistContactDocument,
        variables,
      }),
    }),
    Login: build.mutation<LoginMutation, LoginMutationVariables>({
      query: (variables) => ({ document: LoginDocument, variables }),
    }),
    Login2: build.mutation<Login2Mutation, Login2MutationVariables>({
      query: (variables) => ({ document: Login2Document, variables }),
    }),
    GetReservedContacts: build.query<
      GetReservedContactsQuery,
      GetReservedContactsQueryVariables | void
    >({
      query: (variables) => ({
        document: GetReservedContactsDocument,
        variables,
      }),
    }),
    GetPowerlistUserSession: build.query<
      GetPowerlistUserSessionQuery,
      GetPowerlistUserSessionQueryVariables | void
    >({
      query: (variables) => ({
        document: GetPowerlistUserSessionDocument,
        variables,
      }),
    }),
    GetPowerlistWithTeamByUserId: build.query<
      GetPowerlistWithTeamByUserIdQuery,
      GetPowerlistWithTeamByUserIdQueryVariables | void
    >({
      query: (variables) => ({
        document: GetPowerlistWithTeamByUserIdDocument,
        variables,
      }),
    }),
    Directory: build.query<DirectoryQuery, DirectoryQueryVariables | void>({
      query: (variables) => ({ document: DirectoryDocument, variables }),
    }),
    Connection: build.query<ConnectionQuery, ConnectionQueryVariables | void>({
      query: (variables) => ({ document: ConnectionDocument, variables }),
    }),
    Connection2: build.query<
      Connection2Query,
      Connection2QueryVariables | void
    >({
      query: (variables) => ({ document: Connection2Document, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const {
  useCreateEventMutation,
  useSubscribePowerlistsMutation,
  useStartDialingMutation,
  useDialCurrentPowerlistTargetMutation,
  usePausePowerlistSessionMutation,
  useResumePowerlistSessionMutation,
  useReservePowerlistContactsMutation,
  useEndPowerlistSessionMutation,
  useDialNextPowerlistMutation,
  useSaveOutcomePowerlistMutation,
  useReschedulePowerlistContactMutation,
  useDeletePowerlistContactMutation,
  useLoginMutation,
  useLogin2Mutation,
  useGetReservedContactsQuery,
  useLazyGetReservedContactsQuery,
  useGetPowerlistUserSessionQuery,
  useLazyGetPowerlistUserSessionQuery,
  useGetPowerlistWithTeamByUserIdQuery,
  useLazyGetPowerlistWithTeamByUserIdQuery,
  useDirectoryQuery,
  useLazyDirectoryQuery,
  useConnectionQuery,
  useLazyConnectionQuery,
  useConnection2Query,
  useLazyConnection2Query,
} = injectedRtkApi;
// -----------------------------
// !!! END OF GENERATED FILE !!!
// -----------------------------
export { injectedRtkApi as gqlQuery };
